import { emptySplitBaseApi as api } from "./emptyBaseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    handleCoinBaseWebhook: build.mutation<
      HandleCoinBaseWebhookApiResponse,
      HandleCoinBaseWebhookApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/webhooks/coinBaseWebhook`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getPresignedUrl: build.mutation<
      GetPresignedUrlApiResponse,
      GetPresignedUrlApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/video/getPresignedUrl`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getPresignedUrlForChat: build.mutation<
      GetPresignedUrlForChatApiResponse,
      GetPresignedUrlForChatApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/video/getPresignedUrlForChat`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getRecommendedVideos: build.mutation<
      GetRecommendedVideosApiResponse,
      GetRecommendedVideosApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/video/getRecommendedVideos`,
        method: "POST",
        body: queryArg.getRecommendedVideosRequestDto,
      }),
    }),
    videoBulkUpdate: build.mutation<
      VideoBulkUpdateApiResponse,
      VideoBulkUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/video/videoBulkUpdate`,
        method: "POST",
        body: queryArg.videoBulkUpdateDto,
      }),
    }),
    addVideo: build.mutation<AddVideoApiResponse, AddVideoApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/video/addVideo`,
        method: "POST",
        body: queryArg.addSimpleVideoDto,
      }),
    }),
    getVideos: build.mutation<GetVideosApiResponse, GetVideosApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/video/getVideos`,
        method: "POST",
        body: queryArg.getVideosDto,
      }),
    }),
    getVideoById: build.mutation<GetVideoByIdApiResponse, GetVideoByIdApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/video/getVideoById`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    updateVideo: build.mutation<UpdateVideoApiResponse, UpdateVideoApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/video/updateVideo`,
        method: "PUT",
        body: queryArg.updateSimpleVideoDto,
      }),
    }),
    replaceFilePath: build.mutation<
      ReplaceFilePathApiResponse,
      ReplaceFilePathApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/video/replaceFilePath`,
        method: "PUT",
        body: queryArg.replaceFilePathDto,
      }),
    }),
    deleteVideo: build.mutation<DeleteVideoApiResponse, DeleteVideoApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/video/deleteVideo`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    videoByUrl: build.query<VideoByUrlApiResponse, VideoByUrlApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/video/videoByUrl`,
        params: { url: queryArg.url, isLive: queryArg.isLive },
      }),
    }),
    createVendorProductTimeSlot: build.mutation<
      CreateVendorProductTimeSlotApiResponse,
      CreateVendorProductTimeSlotApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendorProductTimeSlot/create`,
        method: "POST",
        body: queryArg.vendorProductTimeSlotDto,
      }),
    }),
    getVendorProductTimeSlots: build.mutation<
      GetVendorProductTimeSlotsApiResponse,
      GetVendorProductTimeSlotsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendorProductTimeSlot/getVendorProductTimeSlots`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getAvailableTimeSlots: build.mutation<
      GetAvailableTimeSlotsApiResponse,
      GetAvailableTimeSlotsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendorProductTimeSlot/getAvailableTimeSlots`,
        method: "POST",
        body: queryArg.getAvailableTimeSlotsRequestDto,
      }),
    }),
    validateTimeSlot: build.mutation<
      ValidateTimeSlotApiResponse,
      ValidateTimeSlotApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendorProductTimeSlot/validateTimeSlot`,
        method: "POST",
        body: queryArg.validateTimeSlotsRequestDto,
      }),
    }),
    bookTimeSlot: build.mutation<BookTimeSlotApiResponse, BookTimeSlotApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/vendorProductTimeSlot/bookTimeSlot`,
        method: "POST",
        body: queryArg.bookTimeSlotRequestDto,
      }),
    }),
    getUpcomingEvents: build.mutation<
      GetUpcomingEventsApiResponse,
      GetUpcomingEventsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendorProductTimeSlot/getUpcomingEvents`,
        method: "POST",
        body: queryArg.getUpcomingEventsDto,
      }),
    }),
    editBookedEvent: build.mutation<
      EditBookedEventApiResponse,
      EditBookedEventApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendorProductTimeSlot/editBookedEvent`,
        method: "POST",
        body: queryArg.editBookedEventDto,
      }),
    }),
    deleteBookedEvent: build.mutation<
      DeleteBookedEventApiResponse,
      DeleteBookedEventApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendorProductTimeSlot/deleteBookedEvent`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    revokeToken: build.mutation<RevokeTokenApiResponse, RevokeTokenApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/vendorProductTimeSlot/revokeToken`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    vendorSignup: build.mutation<VendorSignupApiResponse, VendorSignupApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/vendor/signup`,
        method: "POST",
        body: queryArg.vendorSignupDto,
      }),
    }),
    vendorLogin: build.mutation<VendorLoginApiResponse, VendorLoginApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/vendor/login`,
        method: "POST",
        body: queryArg.vendorLoginDto,
      }),
    }),
    vendorProducts: build.mutation<
      VendorProductsApiResponse,
      VendorProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendor/products`,
        method: "POST",
        body: queryArg.paginationRequstDto,
      }),
    }),
    getVendorsWithDiscounts: build.mutation<
      GetVendorsWithDiscountsApiResponse,
      GetVendorsWithDiscountsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendor/discounts`,
        method: "POST",
        body: queryArg.nearbyOrDisountedRequestVendorsDto,
      }),
    }),
    getGroupedByVendors: build.query<
      GetGroupedByVendorsApiResponse,
      GetGroupedByVendorsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendor/getGroupedByVendors`,
        params: {
          serviceTypeId: queryArg.serviceTypeId,
          groupedByColumn: queryArg.groupedByColumn,
          latitude: queryArg.latitude,
          longitude: queryArg.longitude,
          cityName: queryArg.cityName,
        },
      }),
    }),
    getVendorsByTagOrServiceTypeId: build.mutation<
      GetVendorsByTagOrServiceTypeIdApiResponse,
      GetVendorsByTagOrServiceTypeIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendor/getVendorsByTagOrServiceTypeId`,
        method: "POST",
        body: queryArg.vendorsByTagOrServiceTypeIdRequestDto,
      }),
    }),
    getRecomendedStores: build.query<
      GetRecomendedStoresApiResponse,
      GetRecomendedStoresApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendor/getRecomendedStores`,
        params: {
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getStoresWithDiscountButNoOrder: build.query<
      GetStoresWithDiscountButNoOrderApiResponse,
      GetStoresWithDiscountButNoOrderApiArg
    >({
      query: () => ({ url: `/api/v1/vendor/getStoresWithDiscountButNoOrder` }),
    }),
    getNearbyVendors: build.mutation<
      GetNearbyVendorsApiResponse,
      GetNearbyVendorsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendor/getNearby`,
        method: "POST",
        body: queryArg.nearbyOrDisountedRequestVendorsDto,
      }),
    }),
    getVendorDetails: build.query<
      GetVendorDetailsApiResponse,
      GetVendorDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendor/getVendorDetails`,
        params: { vendorId: queryArg.vendorId },
      }),
    }),
    getDeliveryCharges: build.mutation<
      GetDeliveryChargesApiResponse,
      GetDeliveryChargesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendor/getDeliveryCharges`,
        method: "POST",
        body: queryArg.deliveryChargesRequestDto,
      }),
    }),
    updateVendorDetails: build.mutation<
      UpdateVendorDetailsApiResponse,
      UpdateVendorDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendor/updateVendorDetails`,
        method: "PUT",
        body: queryArg.editVendorDetailDto,
        params: { vendorId: queryArg.vendorId },
      }),
    }),
    getVendorByIds: build.mutation<
      GetVendorByIdsApiResponse,
      GetVendorByIdsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendor/getVendorByIds`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getVendorBySearch: build.query<
      GetVendorBySearchApiResponse,
      GetVendorBySearchApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendor/getVendorBySearch`,
        params: { search: queryArg.search },
      }),
    }),
    getAllVendorNameOrId: build.query<
      GetAllVendorNameOrIdApiResponse,
      GetAllVendorNameOrIdApiArg
    >({
      query: () => ({ url: `/api/v1/vendor/getAllVendorNameOrId` }),
    }),
    geActiveVendors: build.mutation<
      GeActiveVendorsApiResponse,
      GeActiveVendorsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendor/getActiveVendors`,
        method: "POST",
        body: queryArg.getVendorRequestDto,
      }),
    }),
    getStripeAccountLink: build.query<
      GetStripeAccountLinkApiResponse,
      GetStripeAccountLinkApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/vendor/getStripeAccountLink`,
        params: { vendorId: queryArg.vendorId },
      }),
    }),
    calculateAmount: build.query<
      CalculateAmountApiResponse,
      CalculateAmountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uber/calculateAmount`,
        params: {
          startLat: queryArg.startLat,
          startLng: queryArg.startLng,
          endLat: queryArg.endLat,
          endLng: queryArg.endLng,
        },
      }),
    }),
    bookRide: build.mutation<BookRideApiResponse, BookRideApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/uber/bookRide`,
        method: "POST",
        params: {
          startLat: queryArg.startLat,
          startLng: queryArg.startLng,
          endLat: queryArg.endLat,
          endLng: queryArg.endLng,
        },
      }),
    }),
    getDeliveryStatus: build.query<
      GetDeliveryStatusApiResponse,
      GetDeliveryStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/uber/deliveryStatus`,
        params: { orderId: queryArg.orderId },
      }),
    }),
    addVendorTag: build.mutation<AddVendorTagApiResponse, AddVendorTagApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/tags/addVendorTag`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    updateVendorTag: build.mutation<
      UpdateVendorTagApiResponse,
      UpdateVendorTagApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/updateVendorTag`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getVendorTagById: build.query<
      GetVendorTagByIdApiResponse,
      GetVendorTagByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/getVendorTagById`,
        params: { vendorTagId: queryArg.vendorTagId },
      }),
    }),
    addProductTag: build.mutation<
      AddProductTagApiResponse,
      AddProductTagApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/addProductTag`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    updateProductTag: build.mutation<
      UpdateProductTagApiResponse,
      UpdateProductTagApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/updateProductTag`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getProductTagById: build.query<
      GetProductTagByIdApiResponse,
      GetProductTagByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/getProductTagById`,
        params: { productTagId: queryArg.productTagId },
      }),
    }),
    getTagsBySubcategoryId: build.query<
      GetTagsBySubcategoryIdApiResponse,
      GetTagsBySubcategoryIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/getTagsBySubcategoryId`,
        params: { subCategoryId: queryArg.subCategoryId },
      }),
    }),
    getAllVendorTags: build.mutation<
      GetAllVendorTagsApiResponse,
      GetAllVendorTagsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/getAllVendorTags`,
        method: "POST",
        body: queryArg.getAllVendorTagsRequestDto,
      }),
    }),
    getAllProductTags: build.mutation<
      GetAllProductTagsApiResponse,
      GetAllProductTagsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/getAllProductTags`,
        method: "POST",
        body: queryArg.getAllProductTagsRequestDto,
      }),
    }),
    checkTagUniqueName: build.query<
      CheckTagUniqueNameApiResponse,
      CheckTagUniqueNameApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/tags/checkTagUniqueName`,
        params: {
          tagName: queryArg.tagName,
          tagType: queryArg.tagType,
          serviceTypeId: queryArg.serviceTypeId,
          isUpdateCall: queryArg.isUpdateCall,
          tagId: queryArg.tagId,
        },
      }),
    }),
    createStripeConnectedAccount: build.mutation<
      CreateStripeConnectedAccountApiResponse,
      CreateStripeConnectedAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/stripe/createStripeConnectedAccount`,
        method: "POST",
        body: queryArg.stripeConnectedAccountRequestDto,
      }),
    }),
    payoutToVendor: build.mutation<
      PayoutToVendorApiResponse,
      PayoutToVendorApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/stripe/payoutToVendor`,
        method: "POST",
        body: queryArg.payoutToVendorDto,
      }),
    }),
    deleteStripeAccount: build.query<
      DeleteStripeAccountApiResponse,
      DeleteStripeAccountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/stripe/deleteStripeAccount`,
        params: { stripeAccountId: queryArg.stripeAccountId },
      }),
    }),
    getAllServiceTypes: build.mutation<
      GetAllServiceTypesApiResponse,
      GetAllServiceTypesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/serviceType/getAllServiceTypes`,
        method: "POST",
        body: queryArg.getAllServiceTypesRequestDto,
      }),
    }),
    addServiceType: build.mutation<
      AddServiceTypeApiResponse,
      AddServiceTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/serviceType/addServiceType`,
        method: "POST",
        body: queryArg.addServiceTypeDto,
      }),
    }),
    updateServiceType: build.mutation<
      UpdateServiceTypeApiResponse,
      UpdateServiceTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/serviceType/updateServiceType`,
        method: "PUT",
        body: queryArg.updateServiceTypeDto,
      }),
    }),
    getServiceTypeById: build.query<
      GetServiceTypeByIdApiResponse,
      GetServiceTypeByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/serviceType/getServiceTypeById`,
        params: { id: queryArg.id },
      }),
    }),
    getRatingByCustomer: build.query<
      GetRatingByCustomerApiResponse,
      GetRatingByCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/productRating/getRatingByCustomer`,
        params: {
          productId: queryArg.productId,
          customerId: queryArg.customerId,
        },
      }),
    }),
    canCustomerRate: build.query<
      CanCustomerRateApiResponse,
      CanCustomerRateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/productRating/canCustomerRate`,
        params: {
          productId: queryArg.productId,
          customerId: queryArg.customerId,
        },
      }),
    }),
    getRatingsByProduct: build.query<
      GetRatingsByProductApiResponse,
      GetRatingsByProductApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/productRating/getRatingsByProduct`,
        params: {
          productId: queryArg.productId,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          getTotalCount: queryArg.getTotalCount,
          rating: queryArg.rating,
        },
      }),
    }),
    getRatingsByCustomer: build.query<
      GetRatingsByCustomerApiResponse,
      GetRatingsByCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/productRating/getRatingsByCustomer`,
        params: {
          customerId: queryArg.customerId,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    setReviewSelection: build.mutation<
      SetReviewSelectionApiResponse,
      SetReviewSelectionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/productRating/setReviewSelection`,
        method: "POST",
        body: queryArg.setReviewSelectionRequestDto,
      }),
    }),
    getRatingsByVendor: build.mutation<
      GetRatingsByVendorApiResponse,
      GetRatingsByVendorApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/productRating/getRatingsByVendor`,
        method: "POST",
        body: queryArg.getRatingsByVendorRequestDto,
      }),
    }),
    addUpdateProductRating: build.mutation<
      AddUpdateProductRatingApiResponse,
      AddUpdateProductRatingApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/productRating/addUpdateProductRating`,
        method: "POST",
        body: queryArg.addUpdateProductRatingDto,
      }),
    }),
    getRatingById: build.query<GetRatingByIdApiResponse, GetRatingByIdApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/productRating/getRatingById`,
        params: { productRatingId: queryArg.productRatingId },
      }),
    }),
    addVendorReply: build.mutation<
      AddVendorReplyApiResponse,
      AddVendorReplyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/productRating/addVendorReply`,
        method: "PUT",
        body: queryArg.addVendorReplyDto,
      }),
    }),
    getVendorWiseProducts: build.mutation<
      GetVendorWiseProductsApiResponse,
      GetVendorWiseProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/products/getVendorWiseProducts`,
        method: "POST",
        body: queryArg.paginationRequstDto,
      }),
    }),
    getCategoryWiseProducts: build.mutation<
      GetCategoryWiseProductsApiResponse,
      GetCategoryWiseProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/products/getCategoryWiseProducts`,
        method: "POST",
        body: queryArg.getCategoryWiseProductReqDto,
      }),
    }),
    getSubCategoryWiseProducts: build.mutation<
      GetSubCategoryWiseProductsApiResponse,
      GetSubCategoryWiseProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/products/getSubCategoryWiseProducts`,
        method: "POST",
        body: queryArg.getSubCategoryWiseProductReqDto,
      }),
    }),
    getProducts: build.mutation<GetProductsApiResponse, GetProductsApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/products/getProducts`,
        method: "POST",
        body: queryArg.getProductReqDto,
      }),
    }),
    getProductById: build.query<
      GetProductByIdApiResponse,
      GetProductByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/products/getProductById`,
        params: { productId: queryArg.productId },
      }),
    }),
    getCategory: build.query<GetCategoryApiResponse, GetCategoryApiArg>({
      query: () => ({ url: `/api/v1/products/getCategory` }),
    }),
    searchProduct: build.query<SearchProductApiResponse, SearchProductApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/products/searchProduct`,
        params: {
          searchQuery: queryArg.searchQuery,
          vendorId: queryArg.vendorId,
          latitude: queryArg.latitude,
          longitude: queryArg.longitude,
        },
      }),
    }),
    getSubCategory: build.query<
      GetSubCategoryApiResponse,
      GetSubCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/products/getSubCategory`,
        params: { parentCategoryId: queryArg.parentCategoryId },
      }),
    }),
    addProduct: build.mutation<AddProductApiResponse, AddProductApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/products/addProduct`,
        method: "POST",
        body: queryArg.addProductDto,
      }),
    }),
    editProduct: build.mutation<EditProductApiResponse, EditProductApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/products/editProduct`,
        method: "POST",
        body: queryArg.editProductDto,
      }),
    }),
    deleteProduct: build.mutation<
      DeleteProductApiResponse,
      DeleteProductApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/products/deleteProduct`,
        method: "POST",
        body: queryArg.deleteProductDto,
      }),
    }),
    getPopularProducts: build.query<
      GetPopularProductsApiResponse,
      GetPopularProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/products/popular`,
        params: {
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getRecommendedProducts: build.query<
      GetRecommendedProductsApiResponse,
      GetRecommendedProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/products/getRecommendedProducts`,
        params: {
          serviceTypeId: queryArg.serviceTypeId,
          vendorId: queryArg.vendorId,
          pageNumber: queryArg.pageNumber,
          pageSize: queryArg.pageSize,
          subCategoryId: queryArg.subCategoryId,
          searchQuery: queryArg.searchQuery,
          latitude: queryArg.latitude,
          longitude: queryArg.longitude,
        },
      }),
    }),
    getProductCharacteristicsByid: build.query<
      GetProductCharacteristicsByidApiResponse,
      GetProductCharacteristicsByidApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/products/getProductCharacteristicsByid`,
        params: { productId: queryArg.productId },
      }),
    }),
    getProductRatingStats: build.query<
      GetProductRatingStatsApiResponse,
      GetProductRatingStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/products/getProductRatingStats`,
        params: { productId: queryArg.productId },
      }),
    }),
    checkSkuUnique: build.query<
      CheckSkuUniqueApiResponse,
      CheckSkuUniqueApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/products/checkSkuUnique`,
        params: { sku: queryArg.sku },
      }),
    }),
    getProductByIds: build.mutation<
      GetProductByIdsApiResponse,
      GetProductByIdsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/products/getProductByIds`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getOrders: build.mutation<GetOrdersApiResponse, GetOrdersApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/order/getOrders`,
        method: "POST",
        body: queryArg.getOrderRequestDto,
      }),
    }),
    getOrderById: build.query<GetOrderByIdApiResponse, GetOrderByIdApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/order/getOrder/${queryArg.orderId}`,
        params: { role: queryArg.role },
      }),
    }),
    getOrdersByIds: build.mutation<
      GetOrdersByIdsApiResponse,
      GetOrdersByIdsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/order/getOrdersByIds`,
        method: "POST",
        body: queryArg.orderListDto,
      }),
    }),
    getOrderAndCustomerCounts: build.query<
      GetOrderAndCustomerCountsApiResponse,
      GetOrderAndCustomerCountsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/order/getOrderAndCustomerCounts`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getOrderStatusCounts: build.query<
      GetOrderStatusCountsApiResponse,
      GetOrderStatusCountsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/order/getOrderStatusCounts`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getCustomersCounts: build.query<
      GetCustomersCountsApiResponse,
      GetCustomersCountsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/order/getCustomersCounts`,
        params: { startDate: queryArg.startDate, endDate: queryArg.endDate },
      }),
    }),
    getCustomersRelatedProduct: build.query<
      GetCustomersRelatedProductApiResponse,
      GetCustomersRelatedProductApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/order/getCustomersRelatedProduct`,
        params: {
          productId: queryArg.productId,
          serviceTypeId: queryArg.serviceTypeId,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getDateWiseSalesCounts: build.query<
      GetDateWiseSalesCountsApiResponse,
      GetDateWiseSalesCountsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/order/getDateWiseSalesCounts`,
        params: { salesDate: queryArg.salesDate },
      }),
    }),
    getDateOrDayWiseSales: build.query<
      GetDateOrDayWiseSalesApiResponse,
      GetDateOrDayWiseSalesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/order/getDateOrDayWiseSales`,
        params: { duration: queryArg.duration, vendorId: queryArg.vendorId },
      }),
    }),
    updateOrderStatus: build.mutation<
      UpdateOrderStatusApiResponse,
      UpdateOrderStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/order/${queryArg.orderId}/updateOrderStatus`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteOrders: build.mutation<DeleteOrdersApiResponse, DeleteOrdersApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/order/deleteOrders`,
        method: "POST",
        body: queryArg.orderListDto,
      }),
    }),
    addOrder: build.mutation<AddOrderApiResponse, AddOrderApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/order/addOrder`,
        method: "POST",
        body: queryArg.addOrderDto,
      }),
    }),
    getRecentOrders: build.query<
      GetRecentOrdersApiResponse,
      GetRecentOrdersApiArg
    >({
      query: () => ({ url: `/api/v1/order/recentOrders` }),
    }),
    cancelOrder: build.mutation<CancelOrderApiResponse, CancelOrderApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/order/cancelOrder`,
        method: "POST",
        body: queryArg.cancelOrderDto,
      }),
    }),
    getOrdersByUserId: build.query<
      GetOrdersByUserIdApiResponse,
      GetOrdersByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/order/getOrdersByUserId`,
        params: { serviceTypeId: queryArg.serviceTypeId },
      }),
    }),
    getSingleOrderById: build.query<
      GetSingleOrderByIdApiResponse,
      GetSingleOrderByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/order/getSingleOrderById`,
        params: { orderId: queryArg.orderId },
      }),
    }),
    getOrdersWithVendorId: build.mutation<
      GetOrdersWithVendorIdApiResponse,
      GetOrdersWithVendorIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/order/getOrdersWithVendorId`,
        method: "POST",
        body: queryArg.getOrdersWithVendorIdDto,
      }),
    }),
    pendingPaymentOrders: build.query<
      PendingPaymentOrdersApiResponse,
      PendingPaymentOrdersApiArg
    >({
      query: () => ({ url: `/api/v1/order/getPendingPaymentOrders` }),
    }),
    orderSchedule: build.mutation<
      OrderScheduleApiResponse,
      OrderScheduleApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/order/orderSchedule`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getClickShipRatesForVendor: build.mutation<
      GetClickShipRatesForVendorApiResponse,
      GetClickShipRatesForVendorApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/order/getClickShipRatesForVendor`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    bookShipmentByVendor: build.mutation<
      BookShipmentByVendorApiResponse,
      BookShipmentByVendorApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/order/bookShipmentByVendor`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    saveNotificationToken: build.mutation<
      SaveNotificationTokenApiResponse,
      SaveNotificationTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/notification/saveNotificationToken`,
        method: "POST",
        body: queryArg.saveNotificationTokenDto,
      }),
    }),
    deleteNotificationToken: build.mutation<
      DeleteNotificationTokenApiResponse,
      DeleteNotificationTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/notification/deleteNotificationToken`,
        method: "POST",
        body: queryArg.deleteTokenDto,
      }),
    }),
    testDoordash: build.query<TestDoordashApiResponse, TestDoordashApiArg>({
      query: () => ({ url: `/api/v1/notification/testDoordash` }),
    }),
    sendNotification: build.mutation<
      SendNotificationApiResponse,
      SendNotificationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/notification/sendNotification`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    createLiveSession: build.mutation<
      CreateLiveSessionApiResponse,
      CreateLiveSessionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/liveSession/create`,
        method: "POST",
        body: queryArg.createLiveSessionDto,
      }),
    }),
    updateLiveSession: build.mutation<
      UpdateLiveSessionApiResponse,
      UpdateLiveSessionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/liveSession/update`,
        method: "PUT",
        body: queryArg.updateLiveSessionDto,
      }),
    }),
    getLiveSessions: build.query<
      GetLiveSessionsApiResponse,
      GetLiveSessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/liveSession`,
        params: { vendorId: queryArg.vendorId },
      }),
    }),
    getAllRecordedStreams: build.mutation<
      GetAllRecordedStreamsApiResponse,
      GetAllRecordedStreamsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/liveSession/getAllRecordedStreams`,
        method: "POST",
        body: queryArg.getAllRecordedStreamsRequestDto,
      }),
    }),
    liveSessionUpdate: build.mutation<
      LiveSessionUpdateApiResponse,
      LiveSessionUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/liveSession/liveSessionUpdate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    signupWithEmail: build.mutation<
      SignupWithEmailApiResponse,
      SignupWithEmailApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/customer/signup/email`,
        method: "POST",
        body: queryArg.signupWithEmailDto,
      }),
    }),
    deleteCustomer: build.mutation<
      DeleteCustomerApiResponse,
      DeleteCustomerApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/customer/deleteCustomer`,
        method: "POST",
        body: queryArg.deleteCustomerDto,
      }),
    }),
    signupWithPhone: build.mutation<
      SignupWithPhoneApiResponse,
      SignupWithPhoneApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/customer/signup/phone`,
        method: "POST",
        body: queryArg.signupWithPhoneDto,
      }),
    }),
    verifyOtp: build.mutation<VerifyOtpApiResponse, VerifyOtpApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/customer/verify-otp`,
        method: "POST",
        body: queryArg.verifyOtpDto,
      }),
    }),
    resendOtp: build.mutation<ResendOtpApiResponse, ResendOtpApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/customer/resend-otp`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    customerLogin: build.mutation<
      CustomerLoginApiResponse,
      CustomerLoginApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/customer/login`,
        method: "POST",
        body: queryArg.loginDto,
      }),
    }),
    customerLoginWithPhone: build.mutation<
      CustomerLoginWithPhoneApiResponse,
      CustomerLoginWithPhoneApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/customer/loginWithPhone`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    updateProfile: build.mutation<
      UpdateProfileApiResponse,
      UpdateProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/customer/updateProfile`,
        method: "POST",
        body: queryArg.profileDto,
      }),
    }),
    verifyCouponAndGetVendorWiseAppliedDiscounts: build.mutation<
      VerifyCouponAndGetVendorWiseAppliedDiscountsApiResponse,
      VerifyCouponAndGetVendorWiseAppliedDiscountsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/coupon/verifyCouponAndGetVendorWiseAppliedDiscounts`,
        method: "POST",
        body: queryArg.verifyCouponRequestDto,
      }),
    }),
    verifyCouponAndGetDiscountedValue: build.query<
      VerifyCouponAndGetDiscountedValueApiResponse,
      VerifyCouponAndGetDiscountedValueApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/coupon/verifyCouponAndGetDiscountedValue`,
        params: { couponCode: queryArg.couponCode },
      }),
    }),
    addUpdateCoupon: build.mutation<
      AddUpdateCouponApiResponse,
      AddUpdateCouponApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/coupon/addUpdateCoupon`,
        method: "POST",
        body: queryArg.addUpdateCouponDto,
      }),
    }),
    getCouponStats: build.mutation<
      GetCouponStatsApiResponse,
      GetCouponStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/coupon/getCouponStats`,
        method: "POST",
        body: queryArg.getCouponStatsDto,
      }),
    }),
    getCouponTypes: build.mutation<
      GetCouponTypesApiResponse,
      GetCouponTypesApiArg
    >({
      query: () => ({ url: `/api/v1/coupon/getCouponTypes`, method: "POST" }),
    }),
    couponsWithMaxDiscount: build.mutation<
      CouponsWithMaxDiscountApiResponse,
      CouponsWithMaxDiscountApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/coupon/couponsWithMaxDiscount`,
        method: "POST",
        body: queryArg.couponsWithMaxDiscountDto,
      }),
    }),
    forgotPassword: build.mutation<
      ForgotPasswordApiResponse,
      ForgotPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/common/forgotPassword`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    commonVerifyOtp: build.mutation<
      CommonVerifyOtpApiResponse,
      CommonVerifyOtpApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/common/verifyOtp`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    sendOtp: build.mutation<SendOtpApiResponse, SendOtpApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/common/sendOTP`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    resetPassword: build.mutation<
      ResetPasswordApiResponse,
      ResetPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/common/resetPassword`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    sendContactUsEmail: build.mutation<
      SendContactUsEmailApiResponse,
      SendContactUsEmailApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/common/sendContactUsEmail`,
        method: "POST",
        body: queryArg.contactFormSubmissionDto,
      }),
    }),
    getTotalStats: build.query<GetTotalStatsApiResponse, GetTotalStatsApiArg>({
      query: () => ({ url: `/api/v1/common/getTotalStats` }),
    }),
    addCategory: build.mutation<AddCategoryApiResponse, AddCategoryApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/category/addCategory`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    updateCategory: build.mutation<
      UpdateCategoryApiResponse,
      UpdateCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/category/updateCategory`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getCategoryById: build.query<
      GetCategoryByIdApiResponse,
      GetCategoryByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/category/getCategoryById`,
        params: { categoryId: queryArg.categoryId },
      }),
    }),
    getAllCategories: build.mutation<
      GetAllCategoriesApiResponse,
      GetAllCategoriesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/category/getAllCategories`,
        method: "POST",
        body: queryArg.getAllCategoriesRequestDto,
      }),
    }),
    getAllSubCategories: build.mutation<
      GetAllSubCategoriesApiResponse,
      GetAllSubCategoriesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/category/getAllSubCategories`,
        method: "POST",
        body: queryArg.getAllSubCategoriesRequestDto,
      }),
    }),
    addSubCategory: build.mutation<
      AddSubCategoryApiResponse,
      AddSubCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/category/addSubCategory`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    updateSubCategory: build.mutation<
      UpdateSubCategoryApiResponse,
      UpdateSubCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/category/updateSubCategory`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getSubCategoryById: build.query<
      GetSubCategoryByIdApiResponse,
      GetSubCategoryByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/category/getSubCategoryById`,
        params: { subCategoryId: queryArg.subCategoryId },
      }),
    }),
    checkCategoryUnique: build.query<
      CheckCategoryUniqueApiResponse,
      CheckCategoryUniqueApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/category/checkCategoryUnique`,
        params: { name: queryArg.name, serviceTypeId: queryArg.serviceTypeId },
      }),
    }),
    checkSubCategoryUnique: build.query<
      CheckSubCategoryUniqueApiResponse,
      CheckSubCategoryUniqueApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/category/checkSubCategoryUnique`,
        params: {
          name: queryArg.name,
          parentCategoryId: queryArg.parentCategoryId,
        },
      }),
    }),
    allCategories: build.query<AllCategoriesApiResponse, AllCategoriesApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/category/allCategories`,
        params: {
          vendorId: queryArg.vendorId,
          serviceTypeId: queryArg.serviceTypeId,
        },
      }),
    }),
    getCart: build.query<GetCartApiResponse, GetCartApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/cart/getCart`,
        params: {
          customerId: queryArg.customerId,
          longitude: queryArg.longitude,
          latitude: queryArg.latitude,
        },
      }),
    }),
    deleteCartOrCartItem: build.mutation<
      DeleteCartOrCartItemApiResponse,
      DeleteCartOrCartItemApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/cart/deleteCartOrCartItem`,
        method: "POST",
        body: queryArg.deleteCartRequestDto,
      }),
    }),
    addToCart: build.mutation<AddToCartApiResponse, AddToCartApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/cart/addToCart`,
        method: "POST",
        body: queryArg.addToCartRequestDto,
      }),
    }),
    updateAndGetCart: build.mutation<
      UpdateAndGetCartApiResponse,
      UpdateAndGetCartApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/cart/updateAndGetCart`,
        method: "POST",
        body: queryArg.updateAndGetCartRequestDto,
      }),
    }),
    validateAndGetCart: build.query<
      ValidateAndGetCartApiResponse,
      ValidateAndGetCartApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/cart/validateAndGetCart`,
        params: {
          customerId: queryArg.customerId,
          longitude: queryArg.longitude,
          latitude: queryArg.latitude,
          cartId: queryArg.cartId,
        },
      }),
    }),
    createEvent: build.mutation<CreateEventApiResponse, CreateEventApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/calendar/createEvent`,
        method: "POST",
        body: queryArg.eventDto,
      }),
    }),
    updateEvent: build.mutation<UpdateEventApiResponse, UpdateEventApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/calendar/updateEvent`,
        method: "POST",
        body: queryArg.updateEventDto,
      }),
    }),
    deleteEvent: build.mutation<DeleteEventApiResponse, DeleteEventApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/calendar/deleteEvent`,
        method: "POST",
        body: queryArg.deleteEventDto,
      }),
    }),
    googleLogin: build.query<GoogleLoginApiResponse, GoogleLoginApiArg>({
      query: () => ({ url: `/api/v1/auth/google/login` }),
    }),
    googleGetTokenByCode: build.query<
      GoogleGetTokenByCodeApiResponse,
      GoogleGetTokenByCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/auth/google/getTokenByCode`,
        params: { code: queryArg.code },
      }),
    }),
    googleGetTokenCodeForCalender: build.query<
      GoogleGetTokenCodeForCalenderApiResponse,
      GoogleGetTokenCodeForCalenderApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/auth/google/getTokenCodeForCalender`,
        params: { code: queryArg.code },
      }),
    }),
    appleLogin: build.query<AppleLoginApiResponse, AppleLoginApiArg>({
      query: () => ({ url: `/api/v1/auth/apple/login` }),
    }),
    appleGetTokenByCode: build.mutation<
      AppleGetTokenByCodeApiResponse,
      AppleGetTokenByCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/auth/apple/getTokenByCode`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    addAdmin: build.mutation<AddAdminApiResponse, AddAdminApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/admin/addUpdateAdmin`,
        method: "POST",
        body: queryArg.adminSignupDto,
      }),
    }),
    adminLogin: build.mutation<AdminLoginApiResponse, AdminLoginApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/admin/login`,
        method: "POST",
        body: queryArg.adminLoginDto,
      }),
    }),
    getVendors: build.mutation<GetVendorsApiResponse, GetVendorsApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/admin/getVendors`,
        method: "POST",
        body: queryArg.getVendorRequestDto,
      }),
    }),
    getAdmins: build.mutation<GetAdminsApiResponse, GetAdminsApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/admin/getAdmins`,
        method: "POST",
        body: queryArg.getAdminRequestDto,
      }),
    }),
    updateVendorStatus: build.mutation<
      UpdateVendorStatusApiResponse,
      UpdateVendorStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/updateVendorStatus`,
        method: "PUT",
        body: queryArg.vendorStatusDto,
      }),
    }),
    getLookupValues: build.mutation<
      GetLookupValuesApiResponse,
      GetLookupValuesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/lookupValues`,
        method: "POST",
        body: queryArg.lookupIdDto,
      }),
    }),
    getTagsValues: build.mutation<
      GetTagsValuesApiResponse,
      GetTagsValuesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/getTagsValues`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    addTagsValues: build.mutation<
      AddTagsValuesApiResponse,
      AddTagsValuesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/addTagsValues`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getCustomers: build.mutation<GetCustomersApiResponse, GetCustomersApiArg>({
      query: (queryArg) => ({
        url: `/api/v1/admin/getCustomers`,
        method: "POST",
        body: queryArg.getCustomersReqDto,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as api };
export type HandleCoinBaseWebhookApiResponse = /** status 200 Ok */ {
  received: boolean;
};
export type HandleCoinBaseWebhookApiArg = {
  body: any;
};
export type GetPresignedUrlApiResponse = /** status 200  */ {
  fields: {
    [key: string]: string;
  };
  url: string;
  message: string;
};
export type GetPresignedUrlApiArg = {
  body: {
    isEdit: boolean;
    fileName?: string;
    fileType: string;
    index: number;
  };
};
export type GetPresignedUrlForChatApiResponse = /** status 200  */ {
  fields: {
    [key: string]: string;
  };
  url: string;
  message: string;
};
export type GetPresignedUrlForChatApiArg = {
  body: {
    isEdit: boolean;
    fileName?: string;
    fileType: string;
    index: number;
  };
};
export type GetRecommendedVideosApiResponse = /** status 200  */ {
  data: GetRecommendedVideosResponseDto;
  message: string;
};
export type GetRecommendedVideosApiArg = {
  getRecommendedVideosRequestDto: GetRecommendedVideosRequestDto;
};
export type VideoBulkUpdateApiResponse = /** status 200  */ {
  message: string;
};
export type VideoBulkUpdateApiArg = {
  videoBulkUpdateDto: VideoBulkUpdateDto;
};
export type AddVideoApiResponse =
  /** status 200 Ok */
  | any
  | /** status 201  */ {
      message: string;
    };
export type AddVideoApiArg = {
  addSimpleVideoDto: AddSimpleVideoDto;
};
export type GetVideosApiResponse = /** status 200  */ {
  data: GetVideosResponseDto;
  message: string;
};
export type GetVideosApiArg = {
  getVideosDto: GetVideosDto;
};
export type GetVideoByIdApiResponse = /** status 200  */ {
  data: {
    statusId: number;
    vendorId: number;
    title: string;
    createdAt: string;
    filePath: string;
    id: number;
  };
  message: string;
};
export type GetVideoByIdApiArg = {
  body: {
    id: number;
  };
};
export type UpdateVideoApiResponse = /** status 200  */ {
  message: string;
};
export type UpdateVideoApiArg = {
  updateSimpleVideoDto: UpdateSimpleVideoDto;
};
export type ReplaceFilePathApiResponse = /** status 200  */ {
  message: string;
};
export type ReplaceFilePathApiArg = {
  replaceFilePathDto: ReplaceFilePathDto;
};
export type DeleteVideoApiResponse = /** status 200  */ {
  message: string;
};
export type DeleteVideoApiArg = {
  body: {
    id: number;
  };
};
export type VideoByUrlApiResponse = /** status 200  */ {
  data: GetVideoByUrlResponseDto;
  message: string;
};
export type VideoByUrlApiArg = {
  url: string;
  isLive: boolean;
};
export type CreateVendorProductTimeSlotApiResponse =
  /** status 200 Ok */
  | any
  | /** status 201  */ {
      data: string;
      message: string;
    };
export type CreateVendorProductTimeSlotApiArg = {
  vendorProductTimeSlotDto: VendorProductTimeSlotDto;
};
export type GetVendorProductTimeSlotsApiResponse = /** status 200  */ {
  data: {
    isVenodrAuthorized: boolean;
    vendorProductTimeSlots: GetVendorProductTimeSlotResponseDto[];
  };
  message: string;
};
export type GetVendorProductTimeSlotsApiArg = {
  body: {
    productId?: number;
    vendorId: number;
  };
};
export type GetAvailableTimeSlotsApiResponse = /** status 200  */ {
  data: GetAvailableTimeSlotsResponseDto[];
  message: string;
};
export type GetAvailableTimeSlotsApiArg = {
  getAvailableTimeSlotsRequestDto: GetAvailableTimeSlotsRequestDto;
};
export type ValidateTimeSlotApiResponse = /** status 200  */ {
  data: {
    isAvailable: boolean;
  };
  message: string;
};
export type ValidateTimeSlotApiArg = {
  validateTimeSlotsRequestDto: ValidateTimeSlotsRequestDto;
};
export type BookTimeSlotApiResponse = /** status 200  */ {
  data: BookedVendorProductTimeSlot | null;
  message: string;
};
export type BookTimeSlotApiArg = {
  bookTimeSlotRequestDto: BookTimeSlotRequestDto;
};
export type GetUpcomingEventsApiResponse = /** status 200  */ {
  data: {
    totalPages?: number;
    totalCount?: number;
    upcomingEvents: GetUpcomingEventsResponseDto[];
  } | null;
  message: string;
};
export type GetUpcomingEventsApiArg = {
  getUpcomingEventsDto: GetUpcomingEventsDto;
};
export type EditBookedEventApiResponse = /** status 200  */ {
  data: BookedVendorProductTimeSlot | null;
  message: string;
};
export type EditBookedEventApiArg = {
  editBookedEventDto: EditBookedEventDto;
};
export type DeleteBookedEventApiResponse = /** status 200  */ {
  data: BookedVendorProductTimeSlot | null;
  message: string;
};
export type DeleteBookedEventApiArg = {
  body: {
    id: number;
    calenderEventId: string;
  };
};
export type RevokeTokenApiResponse = /** status 200  */ {
  data: {
    success: boolean;
  };
  message: string;
};
export type RevokeTokenApiArg = {
  body: {
    vendorId: number;
  };
};
export type VendorSignupApiResponse =
  /** status 200 Ok */
  | any
  | /** status 201  */ {
      data: OmitVendorPassword;
      message: string;
    };
export type VendorSignupApiArg = {
  vendorSignupDto: VendorSignupDto;
};
export type VendorLoginApiResponse = /** status 200  */ {
  token: string;
  message: string;
};
export type VendorLoginApiArg = {
  vendorLoginDto: VendorLoginDto;
};
export type VendorProductsApiResponse = /** status 200  */ {
  data: Product[];
  message: string;
};
export type VendorProductsApiArg = {
  paginationRequstDto: PaginationRequstDto;
};
export type GetVendorsWithDiscountsApiResponse = /** status 200  */ {
  data: NearByOrDiscountedVendorDto | null;
  message: string;
};
export type GetVendorsWithDiscountsApiArg = {
  nearbyOrDisountedRequestVendorsDto: NearbyOrDisountedRequestVendorsDto;
};
export type GetGroupedByVendorsApiResponse = /** status 200  */ {
  data: GroupedByVendorsDto[];
  message: string;
};
export type GetGroupedByVendorsApiArg = {
  serviceTypeId: number;
  groupedByColumn: string;
  latitude?: number;
  longitude?: number;
  cityName?: string;
};
export type GetVendorsByTagOrServiceTypeIdApiResponse = /** status 200  */ {
  data: VendorsByTagOrServiceTypeIdResponseDto | null;
  message: string;
};
export type GetVendorsByTagOrServiceTypeIdApiArg = {
  vendorsByTagOrServiceTypeIdRequestDto: VendorsByTagOrServiceTypeIdRequestDto;
};
export type GetRecomendedStoresApiResponse = /** status 200  */ {
  data: VendorWithMaxOrdersDto;
  message: string;
};
export type GetRecomendedStoresApiArg = {
  pageNumber?: number;
  pageSize?: number;
};
export type GetStoresWithDiscountButNoOrderApiResponse = /** status 200  */ {
  data: StoresWithDiscountDto[];
  message: string;
};
export type GetStoresWithDiscountButNoOrderApiArg = void;
export type GetNearbyVendorsApiResponse = /** status 200  */ {
  data: NearByOrDiscountedVendorDto;
  message: string;
};
export type GetNearbyVendorsApiArg = {
  nearbyOrDisountedRequestVendorsDto: NearbyOrDisountedRequestVendorsDto;
};
export type GetVendorDetailsApiResponse = /** status 200  */ {
  data: GetVendorDetailsByIdDto | null;
  message: string;
};
export type GetVendorDetailsApiArg = {
  vendorId: number;
};
export type GetDeliveryChargesApiResponse = /** status 200  */ {
  data: DeliveryChargesDto[];
  message: string;
};
export type GetDeliveryChargesApiArg = {
  deliveryChargesRequestDto: DeliveryChargesRequestDto;
};
export type UpdateVendorDetailsApiResponse = /** status 200  */ {
  data:
    | (OmitVendorPassword & {
        isEligibleForPayout?: boolean | null;
      })
    | null;
  message: string;
};
export type UpdateVendorDetailsApiArg = {
  vendorId: number;
  editVendorDetailDto: EditVendorDetailDto;
};
export type GetVendorByIdsApiResponse = /** status 200  */ {
  data: GetVendorByIdsDto[];
  message: string;
};
export type GetVendorByIdsApiArg = {
  body: {
    userLng?: number;
    userLat?: number;
    vendorIds: number[];
  };
};
export type GetVendorBySearchApiResponse = /** status 200  */ {
  data: GetVendorBySearchDto[];
  message: string;
};
export type GetVendorBySearchApiArg = {
  search: string;
};
export type GetAllVendorNameOrIdApiResponse = /** status 200  */ {
  data: GetAllVendorNameOrId[];
  message: string;
};
export type GetAllVendorNameOrIdApiArg = void;
export type GeActiveVendorsApiResponse = /** status 200  */ {
  data: GetActiveVendorsDto[];
  message: string;
};
export type GeActiveVendorsApiArg = {
  getVendorRequestDto: GetVendorRequestDto;
};
export type GetStripeAccountLinkApiResponse = /** status 200  */ {
  data: {
    url: string | null;
  };
  message: string;
};
export type GetStripeAccountLinkApiArg = {
  vendorId: number;
};
export type CalculateAmountApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type CalculateAmountApiArg = {
  startLat: number;
  startLng: number;
  endLat: number;
  endLng: number;
};
export type BookRideApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type BookRideApiArg = {
  startLat: number;
  startLng: number;
  endLat: number;
  endLng: number;
};
export type GetDeliveryStatusApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type GetDeliveryStatusApiArg = {
  orderId: string;
};
export type AddVendorTagApiResponse = /** status 200  */ {
  message: string;
};
export type AddVendorTagApiArg = {
  body: {
    serviceTypeId: number;
    parentId: number;
    name: string;
  };
};
export type UpdateVendorTagApiResponse = /** status 200  */ {
  message: string;
};
export type UpdateVendorTagApiArg = {
  body: {
    serviceTypeId: number;
    name: string;
    id: number;
  };
};
export type GetVendorTagByIdApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type GetVendorTagByIdApiArg = {
  vendorTagId: number;
};
export type AddProductTagApiResponse = /** status 200  */ {
  message: string;
};
export type AddProductTagApiArg = {
  body: {
    serviceTypeId: number;
    parentId: number;
    name: string;
  };
};
export type UpdateProductTagApiResponse = /** status 200  */ {
  message: string;
};
export type UpdateProductTagApiArg = {
  body: {
    serviceTypeId: number;
    name: string;
    id: number;
  };
};
export type GetProductTagByIdApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type GetProductTagByIdApiArg = {
  productTagId: number;
};
export type GetTagsBySubcategoryIdApiResponse = /** status 200  */ {
  data: TagsModel[];
  message: string;
};
export type GetTagsBySubcategoryIdApiArg = {
  subCategoryId: number;
};
export type GetAllVendorTagsApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type GetAllVendorTagsApiArg = {
  getAllVendorTagsRequestDto: GetAllVendorTagsRequestDto;
};
export type GetAllProductTagsApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type GetAllProductTagsApiArg = {
  getAllProductTagsRequestDto: GetAllProductTagsRequestDto;
};
export type CheckTagUniqueNameApiResponse = /** status 200  */ {
  data: {
    isUnique: boolean;
  };
  message: string;
};
export type CheckTagUniqueNameApiArg = {
  tagName: string;
  tagType: string;
  serviceTypeId: number;
  isUpdateCall: boolean;
  tagId?: number;
};
export type CreateStripeConnectedAccountApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type CreateStripeConnectedAccountApiArg = {
  stripeConnectedAccountRequestDto: StripeConnectedAccountRequestDto;
};
export type PayoutToVendorApiResponse = /** status 200  */ {
  message: string;
};
export type PayoutToVendorApiArg = {
  payoutToVendorDto: PayoutToVendorDto;
};
export type DeleteStripeAccountApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type DeleteStripeAccountApiArg = {
  stripeAccountId: string;
};
export type GetAllServiceTypesApiResponse = /** status 200  */ {
  data: GetAllServiceTypesResponseDto;
  message: string;
};
export type GetAllServiceTypesApiArg = {
  getAllServiceTypesRequestDto: GetAllServiceTypesRequestDto;
};
export type AddServiceTypeApiResponse = /** status 200  */ {
  data: {
    name: string;
    id: number;
  };
  message: string;
};
export type AddServiceTypeApiArg = {
  addServiceTypeDto: AddServiceTypeDto;
};
export type UpdateServiceTypeApiResponse = /** status 200  */ {
  data: {
    name: string;
    id: number;
  };
  message: string;
};
export type UpdateServiceTypeApiArg = {
  updateServiceTypeDto: UpdateServiceTypeDto;
};
export type GetServiceTypeByIdApiResponse = /** status 200  */ {
  data: {
    isDistanceRangApplicable: boolean;
    name: string;
    id: number;
  };
  message: string;
};
export type GetServiceTypeByIdApiArg = {
  id: number;
};
export type GetRatingByCustomerApiResponse = /** status 200  */ {
  data: RatingByCustomerDto;
  message: string;
};
export type GetRatingByCustomerApiArg = {
  productId: number;
  customerId: number;
};
export type CanCustomerRateApiResponse = /** status 200  */ {
  data: boolean;
  message: string;
};
export type CanCustomerRateApiArg = {
  productId: number;
  customerId: number;
};
export type GetRatingsByProductApiResponse = /** status 200  */ {
  data: RatingsByProductDto;
  message: string;
};
export type GetRatingsByProductApiArg = {
  productId: number;
  pageNumber: number;
  pageSize: number;
  getTotalCount: boolean;
  rating?: number;
};
export type GetRatingsByCustomerApiResponse = /** status 200  */ {
  data: RatingsByCustomerDto[];
  message: string;
};
export type GetRatingsByCustomerApiArg = {
  customerId: number;
  pageNumber?: number;
  pageSize?: number;
};
export type SetReviewSelectionApiResponse = /** status 200  */ {
  message: string;
};
export type SetReviewSelectionApiArg = {
  setReviewSelectionRequestDto: SetReviewSelectionRequestDto;
};
export type GetRatingsByVendorApiResponse = /** status 200  */ {
  data: RatingsByVendorDto;
  message: string;
};
export type GetRatingsByVendorApiArg = {
  getRatingsByVendorRequestDto: GetRatingsByVendorRequestDto;
};
export type AddUpdateProductRatingApiResponse = /** status 200  */ {
  data: ProductRatingDto | null;
  message: string;
};
export type AddUpdateProductRatingApiArg = {
  addUpdateProductRatingDto: AddUpdateProductRatingDto;
};
export type GetRatingByIdApiResponse = /** status 200  */ {
  data: GetRatingByIdDto | null;
  message: string;
};
export type GetRatingByIdApiArg = {
  productRatingId: number;
};
export type AddVendorReplyApiResponse = /** status 200  */ {
  message: string;
};
export type AddVendorReplyApiArg = {
  addVendorReplyDto: AddVendorReplyDto;
};
export type GetVendorWiseProductsApiResponse = /** status 200  */ {
  data: VendorProductsDto;
  message: string;
};
export type GetVendorWiseProductsApiArg = {
  paginationRequstDto: PaginationRequstDto;
};
export type GetCategoryWiseProductsApiResponse = /** status 200  */ {
  data: CategoryProductsDto;
  message: string;
};
export type GetCategoryWiseProductsApiArg = {
  getCategoryWiseProductReqDto: GetCategoryWiseProductReqDto;
};
export type GetSubCategoryWiseProductsApiResponse = /** status 200  */ {
  data: SubCategoryProductsDto;
  message: string;
};
export type GetSubCategoryWiseProductsApiArg = {
  getSubCategoryWiseProductReqDto: GetSubCategoryWiseProductReqDto;
};
export type GetProductsApiResponse = /** status 200  */ {
  data: ProductDto[];
  message: string;
};
export type GetProductsApiArg = {
  getProductReqDto: GetProductReqDto;
};
export type GetProductByIdApiResponse = /** status 200  */ {
  data: GetProductResDto | null;
  message: string;
};
export type GetProductByIdApiArg = {
  productId: number;
};
export type GetCategoryApiResponse = /** status 200  */ {
  data: Category[];
  message: string;
};
export type GetCategoryApiArg = void;
export type SearchProductApiResponse = /** status 200  */ {
  data: SearchProductDto[];
  message: string;
};
export type SearchProductApiArg = {
  searchQuery: string;
  vendorId?: number;
  latitude?: number;
  longitude?: number;
};
export type GetSubCategoryApiResponse = /** status 200  */ {
  data: SubCategory[];
  message: string;
};
export type GetSubCategoryApiArg = {
  parentCategoryId: number;
};
export type AddProductApiResponse = /** status 200  */ {
  message: string;
};
export type AddProductApiArg = {
  addProductDto: AddProductDto;
};
export type EditProductApiResponse = /** status 200  */ {
  message: string;
};
export type EditProductApiArg = {
  editProductDto: EditProductDto;
};
export type DeleteProductApiResponse = /** status 200  */ {
  data: Product | null;
  message: string;
};
export type DeleteProductApiArg = {
  deleteProductDto: DeleteProductDto;
};
export type GetPopularProductsApiResponse = /** status 200  */ {
  data: Product[] | null;
  message: string;
};
export type GetPopularProductsApiArg = {
  pageNumber?: number;
  pageSize?: number;
};
export type GetRecommendedProductsApiResponse = /** status 200  */ {
  data: MiniPrductsDto;
  message: string;
};
export type GetRecommendedProductsApiArg = {
  serviceTypeId?: number;
  vendorId?: number;
  pageNumber?: number;
  pageSize?: number;
  subCategoryId?: number;
  searchQuery?: string;
  latitude?: number;
  longitude?: number;
};
export type GetProductCharacteristicsByidApiResponse = /** status 200  */ {
  data: ProductCharacteristics[];
  message: string;
};
export type GetProductCharacteristicsByidApiArg = {
  productId: number;
};
export type GetProductRatingStatsApiResponse = /** status 200  */ {
  data: ProductRatingStats;
  message: string;
};
export type GetProductRatingStatsApiArg = {
  productId: number;
};
export type CheckSkuUniqueApiResponse = /** status 200  */ {
  data: {
    isUnique: boolean;
  };
  message: string;
};
export type CheckSkuUniqueApiArg = {
  sku: string;
};
export type GetProductByIdsApiResponse = /** status 200  */ {
  data: GetProductByIdsResponseDto[];
  message: string;
};
export type GetProductByIdsApiArg = {
  body: {
    productIds: number[];
  };
};
export type GetOrdersApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type GetOrdersApiArg = {
  getOrderRequestDto: GetOrderRequestDto;
};
export type GetOrderByIdApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type GetOrderByIdApiArg = {
  orderId: number;
  role?: string;
};
export type GetOrdersByIdsApiResponse = /** status 200  */ {
  data: GetOrdersDto;
  message: string;
};
export type GetOrdersByIdsApiArg = {
  orderListDto: OrderListDto;
};
export type GetOrderAndCustomerCountsApiResponse = /** status 200  */ {
  data: OrderAndCustomerCountsDto | null;
  message: string;
};
export type GetOrderAndCustomerCountsApiArg = {
  startDate: string;
  endDate: string;
};
export type GetOrderStatusCountsApiResponse = /** status 200  */ {
  data: OrderStatusCountsDto | null;
  message: string;
};
export type GetOrderStatusCountsApiArg = {
  startDate: string;
  endDate: string;
};
export type GetCustomersCountsApiResponse = /** status 200  */ {
  data: CustomerCountDto | null;
  message: string;
};
export type GetCustomersCountsApiArg = {
  startDate: string;
  endDate: string;
};
export type GetCustomersRelatedProductApiResponse = /** status 200  */ {
  data: CustomersRelatedProductDto[];
  message: string;
};
export type GetCustomersRelatedProductApiArg = {
  productId: number;
  serviceTypeId: number;
  pageSize?: number;
};
export type GetDateWiseSalesCountsApiResponse = /** status 200  */ {
  data: DateWiseSalesDto | null;
  message: string;
};
export type GetDateWiseSalesCountsApiArg = {
  salesDate?: string;
};
export type GetDateOrDayWiseSalesApiResponse = /** status 200  */ {
  data: DateOrDayWiseSalesDto;
  message: string;
};
export type GetDateOrDayWiseSalesApiArg = {
  duration: string;
  vendorId?: number;
};
export type UpdateOrderStatusApiResponse = /** status 200  */ {
  message: string;
};
export type UpdateOrderStatusApiArg = {
  orderId: number;
  body: {
    bookedEventId?: number;
    calenderEventId?: string;
    cancellationReason?: string;
    vendorNote?: string;
    statusId: number;
  };
};
export type DeleteOrdersApiResponse = /** status 200  */ {
  data: boolean;
  message: string;
};
export type DeleteOrdersApiArg = {
  orderListDto: OrderListDto;
};
export type AddOrderApiResponse = /** status 200  */ {
  data: AddOrderResponseDto | null;
  message: string;
};
export type AddOrderApiArg = {
  addOrderDto: AddOrderDto;
};
export type GetRecentOrdersApiResponse = /** status 200  */ {
  data: GetRecentOrderDto;
  message: string;
};
export type GetRecentOrdersApiArg = void;
export type CancelOrderApiResponse = /** status 200  */ {
  message: string;
};
export type CancelOrderApiArg = {
  cancelOrderDto: CancelOrderDto;
};
export type GetOrdersByUserIdApiResponse = /** status 200  */ {
  data: GetOrdersByUserIdDto;
  message: string;
};
export type GetOrdersByUserIdApiArg = {
  serviceTypeId: number;
};
export type GetSingleOrderByIdApiResponse = /** status 200  */ {
  data: GetSingleOrderByIdDto;
  message: string;
};
export type GetSingleOrderByIdApiArg = {
  orderId: number;
};
export type GetOrdersWithVendorIdApiResponse = /** status 200  */ {
  data: GetOrdersWithVendorIdResponseDto[];
  message: string;
};
export type GetOrdersWithVendorIdApiArg = {
  getOrdersWithVendorIdDto: GetOrdersWithVendorIdDto;
};
export type PendingPaymentOrdersApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type PendingPaymentOrdersApiArg = void;
export type OrderScheduleApiResponse = /** status 200  */ {
  message: string;
};
export type OrderScheduleApiArg = {
  body: {
    vendorEmail: string;
    orderId: number;
    pickupDateTime: string;
    readyUntil: {
      minute: number;
      hour: number;
    };
    readyAt: {
      minute: number;
      hour: number;
    };
    date: {
      day: number;
      month: number;
      year: number;
    };
    externalDeliveryId: string;
  };
};
export type GetClickShipRatesForVendorApiResponse = /** status 200  */ {
  data: any;
};
export type GetClickShipRatesForVendorApiArg = {
  body: {
    orderItemIds: number[];
    expectedDropoffDateTime?: string | null;
  };
};
export type BookShipmentByVendorApiResponse = /** status 200  */ {
  data: any;
};
export type BookShipmentByVendorApiArg = {
  body: {
    deliveryCharges: number;
    orderId: number;
    clickshipServiceId: string;
    expectedDropoffDate: string;
  };
};
export type SaveNotificationTokenApiResponse = /** status 200  */ {
  data: SaveNotificationTokenDto | null;
  message: string;
} | /** status 204 No content */ void;
export type SaveNotificationTokenApiArg = {
  saveNotificationTokenDto: SaveNotificationTokenDto;
};
export type DeleteNotificationTokenApiResponse = /** status 200  */ {
  data: boolean;
  message: string;
} | /** status 204 No content */ void;
export type DeleteNotificationTokenApiArg = {
  deleteTokenDto: DeleteTokenDto;
};
export type TestDoordashApiResponse = /** status 200  */ {
  data: any;
  message: string;
} | /** status 204 No content */ void;
export type TestDoordashApiArg = void;
export type SendNotificationApiResponse = unknown;
export type SendNotificationApiArg = {
  body: {
    body: string;
    title: string;
    userId: number;
  };
};
export type CreateLiveSessionApiResponse = /** status 200  */ {
  message: string;
};
export type CreateLiveSessionApiArg = {
  createLiveSessionDto: CreateLiveSessionDto;
};
export type UpdateLiveSessionApiResponse = /** status 200  */ {
  message: string;
};
export type UpdateLiveSessionApiArg = {
  updateLiveSessionDto: UpdateLiveSessionDto;
};
export type GetLiveSessionsApiResponse = /** status 200  */ {
  data: GetLiveSessionDto;
};
export type GetLiveSessionsApiArg = {
  vendorId: number;
};
export type GetAllRecordedStreamsApiResponse = /** status 200  */ {
  data: GetRecordedStreamResponseDto;
};
export type GetAllRecordedStreamsApiArg = {
  getAllRecordedStreamsRequestDto: GetAllRecordedStreamsRequestDto;
};
export type LiveSessionUpdateApiResponse = /** status 200  */ {
  data: LiveSessionUpdateResponseDto[];
  message: string;
};
export type LiveSessionUpdateApiArg = {
  body: LiveSessionUpdateRequestDto[];
};
export type SignupWithEmailApiResponse =
  /** status 200 Ok */
  | any
  | /** status 201  */ {
      message: string;
    };
export type SignupWithEmailApiArg = {
  signupWithEmailDto: SignupWithEmailDto;
};
export type DeleteCustomerApiResponse =
  /** status 200 Ok */
  | any
  | /** status 201  */ {
      message: string;
    };
export type DeleteCustomerApiArg = {
  deleteCustomerDto: DeleteCustomerDto;
};
export type SignupWithPhoneApiResponse =
  /** status 200 Ok */
  | any
  | /** status 201  */ {
      message: string;
    };
export type SignupWithPhoneApiArg = {
  signupWithPhoneDto: SignupWithPhoneDto;
};
export type VerifyOtpApiResponse = /** status 200  */ {
  message: string;
  token: string;
};
export type VerifyOtpApiArg = {
  verifyOtpDto: VerifyOtpDto;
};
export type ResendOtpApiResponse = /** status 200  */ {
  message: string;
};
export type ResendOtpApiArg = {
  body: {
    countryCode?: string;
    email?: string;
    phoneNumber?: string;
  };
};
export type CustomerLoginApiResponse = /** status 200  */ {
  token: string;
  message: string;
};
export type CustomerLoginApiArg = {
  loginDto: LoginDto;
};
export type CustomerLoginWithPhoneApiResponse = /** status 200  */ {
  message: string;
};
export type CustomerLoginWithPhoneApiArg = {
  body: {
    countryCode: string;
    phoneNumber: string;
  };
};
export type UpdateProfileApiResponse = /** status 200  */ {
  data: string;
  message: string;
};
export type UpdateProfileApiArg = {
  profileDto: ProfileDto;
};
export type VerifyCouponAndGetVendorWiseAppliedDiscountsApiResponse =
  /** status 200  */ {
    data: VerifyCouponResponseDto | null;
    message: string;
  };
export type VerifyCouponAndGetVendorWiseAppliedDiscountsApiArg = {
  verifyCouponRequestDto: VerifyCouponRequestDto;
};
export type VerifyCouponAndGetDiscountedValueApiResponse = /** status 200  */ {
  data: Coupon | null;
  message: string;
};
export type VerifyCouponAndGetDiscountedValueApiArg = {
  couponCode: string;
};
export type AddUpdateCouponApiResponse = /** status 200  */ {
  message: string;
};
export type AddUpdateCouponApiArg = {
  addUpdateCouponDto: AddUpdateCouponDto;
};
export type GetCouponStatsApiResponse = /** status 200  */ {
  data: CouponStatsResponseDto[];
  message: string;
};
export type GetCouponStatsApiArg = {
  getCouponStatsDto: GetCouponStatsDto;
};
export type GetCouponTypesApiResponse = /** status 200  */ {
  data: CouponType[];
  message: string;
};
export type GetCouponTypesApiArg = void;
export type CouponsWithMaxDiscountApiResponse = /** status 200  */ {
  data: Coupon[] | null;
  message: string;
};
export type CouponsWithMaxDiscountApiArg = {
  couponsWithMaxDiscountDto: CouponsWithMaxDiscountDto;
};
export type ForgotPasswordApiResponse = /** status 200  */ {
  message: string;
};
export type ForgotPasswordApiArg = {
  body: {
    countryCode?: string;
    role: $36EnumsUserRole;
    emailOrPhone: string;
  };
};
export type CommonVerifyOtpApiResponse = /** status 200  */ {
  token: string;
  message: string;
};
export type CommonVerifyOtpApiArg = {
  body: {
    countryCode?: string;
    otp: number;
    role: $36EnumsUserRole;
    emailOrPhone: string;
  };
};
export type SendOtpApiResponse = /** status 200  */ {
  message: string;
};
export type SendOtpApiArg = {
  body: {
    isSimpleOTP?: boolean;
    countryCode?: string;
    role: $36EnumsUserRole;
    emailOrPhone: string;
  };
};
export type ResetPasswordApiResponse = /** status 200  */ {
  token: string;
  message: string;
};
export type ResetPasswordApiArg = {
  body: {
    role: $36EnumsUserRole;
    oldPassword?: string | null;
    newPassword: string;
  };
};
export type SendContactUsEmailApiResponse = /** status 200  */ {
  message: string;
};
export type SendContactUsEmailApiArg = {
  contactFormSubmissionDto: ContactFormSubmissionDto;
};
export type GetTotalStatsApiResponse = /** status 200  */ {
  data: {
    averageRating: number;
    totalRatingCount: number;
    totalProducts: number;
    totalCategories: number;
    totalUsers: number;
  };
};
export type GetTotalStatsApiArg = void;
export type AddCategoryApiResponse = /** status 200  */ {
  message: string;
};
export type AddCategoryApiArg = {
  body: {
    serviceTypeId: number;
    name: string;
  };
};
export type UpdateCategoryApiResponse = /** status 200  */ {
  message: string;
};
export type UpdateCategoryApiArg = {
  body: {
    serviceTypeId: number;
    name: string;
    id: number;
  };
};
export type GetCategoryByIdApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type GetCategoryByIdApiArg = {
  categoryId: number;
};
export type GetAllCategoriesApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type GetAllCategoriesApiArg = {
  getAllCategoriesRequestDto: GetAllCategoriesRequestDto;
};
export type GetAllSubCategoriesApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type GetAllSubCategoriesApiArg = {
  getAllSubCategoriesRequestDto: GetAllSubCategoriesRequestDto;
};
export type AddSubCategoryApiResponse = /** status 200  */ {
  message: string;
};
export type AddSubCategoryApiArg = {
  body: {
    imageBlob?: string;
    imageType?: string;
    parentCategoryId: number;
    name: string;
  };
};
export type UpdateSubCategoryApiResponse = /** status 200  */ {
  message: string;
};
export type UpdateSubCategoryApiArg = {
  body: {
    imageBlob?: string;
    imageType?: string;
    parentCategoryId: number;
    name: string;
    id: number;
  };
};
export type GetSubCategoryByIdApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type GetSubCategoryByIdApiArg = {
  subCategoryId: number;
};
export type CheckCategoryUniqueApiResponse = /** status 200  */ {
  data: {
    isUnique: boolean;
  };
  message: string;
};
export type CheckCategoryUniqueApiArg = {
  name: string;
  serviceTypeId: number;
};
export type CheckSubCategoryUniqueApiResponse = /** status 200  */ {
  data: {
    isUnique: boolean;
  };
  message: string;
};
export type CheckSubCategoryUniqueApiArg = {
  name: string;
  parentCategoryId: number;
};
export type AllCategoriesApiResponse = /** status 200  */ {
  data: AllCategoriesResponseDto[];
  message: string;
};
export type AllCategoriesApiArg = {
  vendorId: number;
  serviceTypeId: number;
};
export type GetCartApiResponse = /** status 200  */ {
  data?: GetCartResponseDto;
  message: string;
};
export type GetCartApiArg = {
  customerId: number;
  longitude?: number;
  latitude?: number;
};
export type DeleteCartOrCartItemApiResponse = /** status 200  */ {
  data: boolean;
  message: string;
};
export type DeleteCartOrCartItemApiArg = {
  deleteCartRequestDto: DeleteCartRequestDto;
};
export type AddToCartApiResponse = /** status 200  */ {
  data: AddToCartResponseDto | null;
  message: string;
};
export type AddToCartApiArg = {
  addToCartRequestDto: AddToCartRequestDto;
};
export type UpdateAndGetCartApiResponse = /** status 200  */ {
  data: GetCartResponseDto | null;
  message: string;
};
export type UpdateAndGetCartApiArg = {
  updateAndGetCartRequestDto: UpdateAndGetCartRequestDto;
};
export type ValidateAndGetCartApiResponse = /** status 200  */ {
  data: ValidateAndGetCartDto | null;
  message: string;
};
export type ValidateAndGetCartApiArg = {
  customerId: number;
  longitude?: number;
  latitude?: number;
  cartId?: number;
};
export type CreateEventApiResponse =
  /** status 200 Ok */
  | any
  | /** status 201  */ {
      data: any;
      message: string;
    };
export type CreateEventApiArg = {
  eventDto: EventDto;
};
export type UpdateEventApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type UpdateEventApiArg = {
  updateEventDto: UpdateEventDto;
};
export type DeleteEventApiResponse = /** status 200  */ {
  data: any;
  message: string;
};
export type DeleteEventApiArg = {
  deleteEventDto: DeleteEventDto;
};
export type GoogleLoginApiResponse = /** status 200  */ {
  url: string;
};
export type GoogleLoginApiArg = void;
export type GoogleGetTokenByCodeApiResponse = /** status 200  */ {
  data: SsoLoginResponseDto | null;
  message: string;
};
export type GoogleGetTokenByCodeApiArg = {
  code: string;
};
export type GoogleGetTokenCodeForCalenderApiResponse = /** status 200  */ {
  data: "";
  message: string;
};
export type GoogleGetTokenCodeForCalenderApiArg = {
  code: string;
};
export type AppleLoginApiResponse = /** status 200  */ {
  url: string;
};
export type AppleLoginApiArg = void;
export type AppleGetTokenByCodeApiResponse = /** status 200  */ {
  data: SsoLoginResponseDto | null;
  message: string;
};
export type AppleGetTokenByCodeApiArg = {
  body: {
    code: string;
  };
};
export type AddAdminApiResponse =
  /** status 200 Ok */
  | any
  | /** status 201  */ {
      data: string;
      message: string;
    };
export type AddAdminApiArg = {
  adminSignupDto: AdminSignupDto;
};
export type AdminLoginApiResponse = /** status 200  */ {
  token: string;
  message: string;
};
export type AdminLoginApiArg = {
  adminLoginDto: AdminLoginDto;
};
export type GetVendorsApiResponse = /** status 200  */ {
  data: GetVendorsDto[];
  message: string;
};
export type GetVendorsApiArg = {
  getVendorRequestDto: GetVendorRequestDto;
};
export type GetAdminsApiResponse = /** status 200  */ {
  data: GetAdminResponseDto[];
  message: string;
};
export type GetAdminsApiArg = {
  getAdminRequestDto: GetAdminRequestDto;
};
export type UpdateVendorStatusApiResponse = /** status 200  */ {
  data: OmitVendorPassword;
  message: string;
};
export type UpdateVendorStatusApiArg = {
  vendorStatusDto: VendorStatusDto;
};
export type GetLookupValuesApiResponse = /** status 200  */ {
  data: Lookup[];
  message: string;
};
export type GetLookupValuesApiArg = {
  lookupIdDto: LookupIdDto;
};
export type GetTagsValuesApiResponse = /** status 200  */ {
  data: TagsResponseDto[];
  message: string;
};
export type GetTagsValuesApiArg = {
  body: {
    serviceTypeIdTo?: number;
    serviceTypeIdFrom?: number;
    tagId: number | null;
  };
};
export type AddTagsValuesApiResponse = /** status 200  */ {
  message: string;
};
export type AddTagsValuesApiArg = {
  body: {
    serviceTypeId: number;
    parentId: number | null;
    name: string;
  }[];
};
export type GetCustomersApiResponse = /** status 200  */ {
  data: GetCustomerResDto;
  message: string;
};
export type GetCustomersApiArg = {
  getCustomersReqDto: GetCustomersReqDto;
};
export type LiveSessionProductDto = {
  productId: number;
  productName: string;
  price: number;
  defaultImageUrl: string;
  oldPrice?: number | null;
  rating?: number | null;
  quantityAvailable?: number;
};
export type GetRecommendedVideosResponseDto = {
  videos?: {
    liveSessionUrl?: string | null;
    isLive?: boolean;
    productName?: string | null;
    title: string | null;
    serviceTypeId: number | null;
    vendorImage?: string | null;
    productId?: number | null;
    totalViews: number;
    totalLikes: number;
    vendorName?: string | null;
    vendorId?: number | null;
    filePath: string;
    id: number;
  }[];
  liveVideos?: {
    products: LiveSessionProductDto[];
    fileType: number;
    title: string | null;
    serviceTypeId: number | null;
    vendorImage: string | null;
    totalViews: number;
    totalLikes: number;
    vendorName: string | null;
    vendorId: number | null;
    filePath: string;
    id: number;
  }[];
};
export type GetRecommendedVideosRequestDto = {
  rankNumber?: number;
  notInclude?: number[];
  notIncludeLive?: number[];
  isLiveOnly?: boolean;
};
export type VideoBulkUpdateDto = {
  actions: {
    id: number;
    action: string;
  }[];
};
export type AddSimpleVideoDto = {
  filePath: string;
  vendorId?: number;
  title: string;
};
export type GetVideosResponseDto = {
  totalCount?: number;
  totalPages?: number;
  videos: {
    videoStatus: string;
    statusId: number;
    totalViews: number;
    totalDislikes: number;
    totalLikes: number;
    createdAt: string;
    title: string;
    filePath: string;
    id: number;
  }[];
};
export type GetVideosDto = {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
  vendorId?: number;
  startDate?: string;
  endDate?: string;
};
export type UpdateSimpleVideoDto = {
  filePath: string;
  vendorId?: number;
  title: string;
  id: number;
  deletedVideoFileObj?: {
    filePath: string;
  };
};
export type ReplaceFilePathDto = {
  oldFilePath: string;
  newFilePath?: string | null;
  statusId: number;
};
export type GetVideoByUrlResponseDto = {
  id: number;
  filePath: string;
  vendorId?: number | null;
  vendorName?: string | null;
  totalLikes: number;
  totalViews: number;
  productId?: number | null;
  vendorImage?: string | null;
  serviceTypeId: number | null;
  title: string | null;
  productName?: string | null;
  products?: LiveSessionProductDto[];
};
export type VendorProductTimeSlotDto = {
  vendorId: number;
  productId?: number | null;
  removedTimeSlotIds?: number[];
  timeSlots?: {
    dayOfWeek?: string;
    endTime: string;
    startTime: string;
  }[];
  blockDate?: string[];
};
export type GetVendorProductTimeSlotResponseDto = {
  id: number;
  vendorId: number;
  productId: number | null;
  startTime: string;
  endTime: string;
  dayOfWeek: string | null;
};
export type GetAvailableTimeSlotsResponseDto = {
  startTime: string;
  endTime: string;
};
export type GetAvailableTimeSlotsRequestDto = {
  vendorId: number;
  productId: number;
  appointmentDate: string;
};
export type ValidateTimeSlotsRequestDto = {
  startTime: string;
  endTime: string;
  vendorId: number;
  productId: number;
};
export type DefaultSelectionPrisma36BookedVendorProductTimeSlotPayload = {
  deleted: boolean;
  longitude: number;
  latitude: number;
  googleMeetLink: string;
  calenderLink: string;
  calenderEventId: string;
  endTime: string;
  startTime: string;
  createdAt: string;
  bookingDate: string;
  productId: number;
  vendorId: number;
  customerId: number;
  id: number;
};
export type BookedVendorProductTimeSlot =
  DefaultSelectionPrisma36BookedVendorProductTimeSlotPayload;
export type BookTimeSlotRequestDto = {
  vendorId: number;
  productId: number;
  startTime: string;
  endTime: string;
  vendorName: string;
  vendorEmail: string;
  location: string;
  timeZone: string;
  orderIds: number[];
  latitude?: number | null;
  longitude?: number | null;
  modeId: number;
};
export type GetUpcomingEventsResponseDto = {
  id: number;
  customerId: number;
  vendorId: number;
  productId: number | null;
  bookingDate: string;
  createdAt: string;
  startTime: string;
  endTime: string;
  calenderEventId: string;
  calenderLink: string | null;
  deleted: boolean;
  customerName: string;
  orderId: number | null;
  productModeId?: number | null;
};
export type GetUpcomingEventsDto = {
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  vendorId?: number;
  productId?: number;
  customerId?: number;
  isPastEvents?: boolean;
  currentDate?: string;
};
export type EditBookedEventDto = {
  id: number;
  startTime: string;
  endTime: string;
  calenderEventId?: string | null;
  timeZone: string;
};
export type $36EnumsUserRole = "CUSTOMER" | "VENDOR" | "ADMIN" | "SYSTEM";
export type PickVendorExcludeKeyofVendorPassword = {
  id: number;
  createdAt: string;
  latitude: number;
  longitude: number;
  deleted: boolean;
  email: string;
  firstName: string;
  lastName: string;
  company: string;
  vendorImage: string;
  wallpaperImageUrl: string;
  liveSessionUrl: string;
  website: string;
  phone: string;
  countryCode: string;
  address: string;
  cityName: string;
  country: string;
  state: string;
  zipCode: string;
  statusId: number;
  isCatering: boolean;
  isDoorDash: boolean;
  numberOfStores: number;
  soucreOfInformation: string;
  deliveryInformaiton: string;
  themeColor: string;
  OTP: number;
  otpSentAt: string;
  otpExpiresAt: string;
  updatedAt: string;
  role: $36EnumsUserRole;
  rating: number;
  stripeAccountId: string;
  aboutStore: string;
  returnInfo: string;
  SSN: string;
  DOB: string;
  merchantCode: string;
  accountHolderName: string;
  bankName: string;
  accountNumber: string;
  routingNumber: string;
  swiftCode: string;
  vendorUuid: string;
  standardDeliveryFee: number;
  tagLine: string;
  serviceTypeId: number;
  isLive: boolean;
};
export type OmitVendorPassword = PickVendorExcludeKeyofVendorPassword;
export type VendorSignupDto = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  company: string;
  website?: string;
  phone?: string;
  address: string;
  cityName: string;
  themeColor?: string;
  vendorImageBlob?: string;
  vendorImagecontentType?: string;
  wallpaperImageBlob?: string;
  wallpaperImagecontentType?: string;
  deliveryInformaiton?: string;
  state: string;
  zipCode: string;
  serviceTypeId: number;
  numberOfStores?: number;
  soucreOfInformation?: string;
  countryCode?: string;
  country?: string | null;
  latitude: number;
  longitude: number;
};
export type VendorLoginDto = {
  email: string;
  password: string;
};
export type $36EnumsDiscountType = "PERCENTAGE" | "FLAT";
export type DefaultSelectionPrisma36ProductPayload = {
  deleted: boolean;
  updatedAt: string;
  createdAt: string;
  quantityAvailable: number;
  discountValue: number;
  discountType: $36EnumsDiscountType;
  modeId: number;
  statusId: number;
  subCategoryId: number;
  expectedShipHours: number;
  rating: number;
  price: number;
  sku: string;
  weight: number;
  weightUnit: string;
  description: string;
  productName: string;
  defaultImageUrl: string;
  vendorId: number;
  id: number;
};
export type Product = DefaultSelectionPrisma36ProductPayload;
export type PaginationRequstDto = {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
};
export type MiniVendorsDto = {
  vendorId: number;
  latitude?: number;
  longitude?: number;
  email?: string;
  company: string;
  vendorImage?: string;
  liveSessionUrl?: string | null;
  phone?: string;
  address?: string;
  cityName?: string;
  themeColor?: string;
  rating?: number;
  aboutStore?: string;
  returnInfo?: string;
  tagLine?: string;
  isLive?: boolean;
  estimatedDeliveryTime?: string;
  distance?: string;
  distanceWithOutUnit?: number;
  deliveryCharges?: string;
  deliveryChargesAsNumber?: number;
  vendorTags?: {
    tagName: string;
    tagId?: number;
  }[];
  wallpaperImageUrl?: string | null;
  totalAmountToBePaid?: number | null;
  isQuickDeliveryApplicable?: boolean | null;
  isStandardDeliveryApplicable?: boolean | null;
};
export type NearByOrDiscountedVendorDto = {
  totalCount?: number;
  totalPages?: number;
  vendors: MiniVendorsDto[];
};
export type NearbyOrDisountedRequestVendorsDto = {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
  serviceTypeId?: number;
  cityName?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  tagId?: number | null;
};
export type PickMiniVendorsDtoExcludeKeyofMiniVendorsDtoVendorTags = {
  vendorId: number;
  latitude?: number;
  longitude?: number;
  email?: string;
  company: string;
  vendorImage?: string;
  wallpaperImageUrl?: string;
  liveSessionUrl?: string;
  phone?: string;
  address?: string;
  cityName?: string;
  themeColor?: string;
  rating?: number;
  aboutStore?: string;
  returnInfo?: string;
  tagLine?: string;
  isLive?: boolean;
  estimatedDeliveryTime?: string;
  distance?: string;
  distanceWithOutUnit?: number;
  deliveryCharges?: string;
  deliveryChargesAsNumber?: number;
  totalAmountToBePaid?: number;
  isQuickDeliveryApplicable?: boolean;
  isStandardDeliveryApplicable?: boolean;
};
export type OmitMiniVendorsDtoVendorTags =
  PickMiniVendorsDtoExcludeKeyofMiniVendorsDtoVendorTags;
export type GroupedByVendorsDto = {
  groupId: number;
  groupName: string;
  groupVendorsCount: number;
  groupedByColumn: string;
  vendors: OmitMiniVendorsDtoVendorTags[];
};
export type VendorsByTagOrServiceTypeIdResponseDto = {
  totalCount?: number;
  totalPages?: number;
  vendors: OmitMiniVendorsDtoVendorTags[];
};
export type VendorsByTagOrServiceTypeIdRequestDto = {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
  groupId: number;
  latitude?: number;
  longitude?: number;
  groupedByColumn: string;
  cityName?: string;
};
export type VendorWithMaxOrder = {
  id: number;
  company: string;
  orderItemCount: number;
};
export type VendorWithMaxOrdersDto = {
  totalCount?: number;
  totalPages?: number;
  vendors: VendorWithMaxOrder[];
};
export type StoresWithDiscountDto = {
  vendorId: number;
  company: string;
  productId: number;
  description: string;
  discountValue: number;
  quantityAvailable: number;
  discountType: string;
  price: number;
  productName: string;
};
export type VendorTagsDto = {
  tagId: number;
  tagName: string;
  vendorId: number;
  id: number;
};
export type GetVendorDetailsByIdDto = {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  company: string;
  vendorImage: string | null;
  DOB: string | null;
  wallpaperImageUrl: string | null;
  website: string | null;
  phone: string | null;
  countryCode?: string | null;
  address: string;
  cityName: string;
  state: string;
  zipCode: string;
  latitude?: number | null;
  longitude?: number | null;
  serviceTypeId: number;
  numberOfStores: number;
  themeColor?: string | null;
  vendorTags: VendorTagsDto[];
  aboutStore?: string | null;
  returnInfo?: string | null;
  tagLine?: string | null;
  SSN?: string | null;
  merchantCode?: string | null;
  accountHolderName?: string | null;
  bankName?: string | null;
  accountNumber?: string | null;
  routingNumber?: string | null;
  swiftCode?: string | null;
  standardDeliveryFee?: number | null;
  isEligibleForPayout?: boolean | null;
  stripeAccountId?: string | null;
};
export type DeliveryChargesAndTime = {
  deliveryCharges?: number;
  estimatedDeliveryTime?: string;
  externalDeliveryId?: string;
  message?: string;
};
export type ClickshipServicesRatesDto = {
  serviceId: string;
  carrierName: string;
  serviceName: string;
  deliveryCharges: number;
  estimatedDeliveryTime: string;
};
export type DeliveryChargesDto = {
  vendorId: number;
  standardDelivery?: DeliveryChargesAndTime | null;
  quickDelivery?: DeliveryChargesAndTime | null;
  postalDelivery?: DeliveryChargesAndTime | null;
  clickshipServicesRates?: ClickshipServicesRatesDto[] | null;
};
export type DeliveryChargesRequestCustomer = {
  email: string;
  name: string;
  address: string;
  phoneNumber: string;
  latitude: number;
  longitude: number;
  city: string;
  region: string;
  country: string;
  postalCode: string;
  phoneExtention: string;
  expectedDropoffDateTime?: string;
};
export type DeliveryChargesRequestDto = {
  cartId: number;
  clickshipServiceId?: string | null;
  customerInfo: DeliveryChargesRequestCustomer;
  vendors?: {
    customerNote: string;
    vendorId: number;
  }[];
};
export type AddVendorTagsDto = {
  id?: number;
  tagId: number;
  vendorId: number;
};
export type RemoveVendorTagsDto = {
  id: number;
};
export type EditVendorDetailDto = {
  email: string;
  firstName: string;
  lastName: string;
  company: string;
  vendorImage: string | null;
  website: string | null;
  phone: string | null;
  address: string;
  cityName: string;
  state: string;
  zipCode: string;
  country?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  serviceTypeId: number;
  numberOfStores: number;
  themeColor?: string | null;
  id: number;
  DOB?: string;
  vendorImageType?: string;
  vendorImageBlob?: string;
  wallpaperImageUrl?: string | null;
  wallpaperImageType?: string;
  wallpaperImageBlob?: string;
  vendorTags?: AddVendorTagsDto[];
  removedTags?: RemoveVendorTagsDto[];
  aboutStore?: string | null;
  returnInfo?: string | null;
  SSN?: string | null;
  countryCode: string | null;
  merchantCode?: string | null;
  accountHolderName?: string | null;
  bankName?: string | null;
  accountNumber?: string | null;
  routingNumber?: string | null;
  swiftCode?: string | null;
  standardDeliveryFee?: number | null;
  tagLine?: string | null;
  timeSlots?: {
    dayOfWeek?: string;
    endTime: string;
    startTime: string;
  }[];
  blockDate?: string[];
  removedTimeSlotIds?: number[];
};
export type SimpleVendorDto = {
  vendorId: number;
  rating?: number | null;
  latitude?: number | null;
  serviceTypeId: number;
  longitude?: number | null;
  company: string;
  themeColor?: string;
  phone?: string;
  address?: string;
  email?: string;
  cityName?: string;
  returnInfo?: string | null;
  aboutStore?: string | null;
  tagLine?: string | null;
  statusName: string;
  vendorImage?: string;
  estimatedDeliveryTime?: string | null;
  distance?: string | null;
  distanceWithOutUnit?: number | null;
  deliveryCharges?: string | null;
  deliveryChargesAsNumber?: number | null;
  isLive?: boolean | null;
  liveSessionUrl?: string | null;
  vendorTags?: {
    tagName: string;
    tagId?: number;
  }[];
};
export type GetVendorByIdsDto = {
  vendors: SimpleVendorDto[];
};
export type GetVendorBySearchDto = {
  id: string;
  company: string;
  phone: string | null;
  countryCode: string | null;
  SSN: string | null;
  merchantCode: string | null;
  accountHolderName: string | null;
  bankName: string | null;
  accountNumber: string | null;
  routingNumber: string | null;
  swiftCode: string | null;
  DOB: string | null;
};
export type GetAllVendorNameOrId = {
  id: number;
  company: string;
};
export type GetActiveVendorsDto = {
  totalCount?: number;
  totalPages?: number;
  id: number;
  company: string;
  serviceTypeName: string;
  vendorImage: string;
  cityName: string;
};
export type GetVendorRequestDto = {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
  statusId?: number;
  startDate?: string;
  endDate?: string;
  serviceTypeId?: number;
};
export type DefaultSelectionPrisma36TagsPayload = {
  serviceTypeId: number;
  parentId: number;
  name: string;
  id: number;
};
export type TagsModel = DefaultSelectionPrisma36TagsPayload;
export type GetAllVendorTagsRequestDto = {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
  vendorParentTagId: number;
  serviceTypeId?: number;
};
export type GetAllProductTagsRequestDto = {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
  productParentTagId: number;
  serviceTypeId?: number;
};
export type StripeConnectedAccountRequestDto = {
  email: string;
  accountHolderName: string;
  routingNumber: string;
  accountNumber: string;
  ipAddress?: string;
  firstName?: string;
  lastName?: string;
  ssnLast4?: string;
  ssn?: string;
  phone?: string;
  city?: string;
  line1?: string;
  postalCode?: string;
  state?: string;
  dobDay?: number;
  dobMonth?: number;
  dobYear?: number;
  webSiteUrl?: string;
  mcc?: string;
};
export type PayoutToVendorDto = {
  orderIds: number[];
};
export type GetAllServiceTypesResponseDto = {
  totalCount?: number;
  totalPages?: number;
  serviceTypes: {
    isDistanceRangApplicable: boolean;
    name: string;
    id: number;
  }[];
};
export type GetAllServiceTypesRequestDto = {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
  isDistanceRangApplicable?: boolean;
};
export type AddServiceTypeDto = {
  name: string;
  isDistanceRangApplicable: boolean;
};
export type UpdateServiceTypeDto = {
  name: string;
  isDistanceRangApplicable: boolean;
  id: number;
};
export type ProductRatingDto = {
  productRatingId?: number | null;
  productId: number;
  vendorId: number;
  customerId: number;
  rating: number | null;
  review: string | null;
  vendorNote: string | null;
  vendorReply?: string | null;
  orderId: number;
  vendorReplyDate?: string | null;
  orderDate?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  multimedia?:
    | {
        fileType: string;
        filePath: string;
        id?: number;
      }[]
    | null;
};
export type RatingByCustomerDto = {
  productRating?: ProductRatingDto;
};
export type RatingsByProduct = {
  productRatingId?: number | null;
  productId: number;
  vendorId: number;
  customerId: number;
  rating: number | null;
  review: string | null;
  vendorNote: string | null;
  vendorReply?: string | null;
  orderId: number;
  vendorReplyDate?: string | null;
  orderDate?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  multimedia?:
    | {
        fileType: string;
        filePath: string;
        id?: number;
      }[]
    | null;
  customerName: string;
};
export type RatingsByProductDto = {
  totalCount?: number;
  totalPages?: number;
  productRatings: RatingsByProduct[];
};
export type RatingsByCustomerDto = {
  productRatingId?: number | null;
  productId: number;
  vendorId: number;
  customerId: number;
  rating: number | null;
  review: string | null;
  vendorNote: string | null;
  vendorReply?: string | null;
  orderId: number;
  vendorReplyDate?: string | null;
  orderDate?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  multimedia?:
    | {
        fileType: string;
        filePath: string;
        id?: number;
      }[]
    | null;
  customerName: string;
  productName: string;
  description: string;
  productImage: string;
  vendorName: string;
  vendorImage: string | null;
};
export type SetReviewSelectionRequestDto = {
  productRatingIds: number[];
  vendorId: number;
  productId: number;
};
export type ProductForVendorDto = {
  productId: number;
  productRating?: number | null;
  productName: string;
  productImage: string;
  vendorName: string;
  vendorId: number;
  customerName: string;
  productRatingId: number;
  ratingValue: number;
  review: string;
  vendorReply: string | null;
  vendorReplyDate: string | null;
  orderDate: string;
  createdAt: string;
  updatedAt: string;
};
export type RatingsByVendorDto = {
  totalCount?: number;
  totalPages?: number;
  products: ProductForVendorDto[];
};
export type GetRatingsByVendorRequestDto = {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
  vendorId?: number;
  startDate?: string;
  endDate?: string;
};
export type AddUpdateProductRatingDto = {
  productRatingId?: number | null;
  productId: number;
  vendorId: number;
  customerId: number;
  rating: number | null;
  review: string | null;
  orderId: number;
  orderDate: string;
  addMedia?:
    | {
        fileType: number;
        filePath: string;
        order: number;
      }[]
    | null;
  removeMedia?:
    | {
        filePath: string;
        id: number;
      }[]
    | null;
};
export type GetRatingByIdDto = {
  productRatingId: number;
  vendorId: number;
  rating: number | null;
  review: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  vendorReplyDate?: string | null;
  vendorReply: string | null;
  vendorName: string;
  vendorImage: string;
  customerName: string;
  productName: string;
  productDescription: string;
  productImage: string;
  multimedia: {
    fileType: string;
    filePath: string;
  }[];
};
export type AddVendorReplyDto = {
  productRatingId: number;
  vendorReply: string;
};
export type ProductDto = {
  defaultImageUrl: string;
  productName: string;
  sku: string;
  category: string;
  categoryId: number;
  company: string;
  vendorId: number;
  subCategory: string;
  subCategoryId: number;
  status: string;
  statusId: number;
  price: number;
  oldPrice?: number | null;
  weight?: number | null;
  tags?: string[];
  weightUnit?: number | null;
  expectedShipHours?: number | null;
  productId?: number;
  quantityAvailable?: number;
  description: string;
  createdAt: string;
  modeId?: number | null;
  rating?: number | null;
};
export type GroupdProductDto = {
  vendorId: number;
  categoryId: number;
  subCategoryId: number;
  products: ProductDto[];
};
export type VendorProductsDto = {
  totalCount?: number;
  totalPages?: number;
  vendors: GroupdProductDto[];
};
export type CategoryProductDto = {
  categoryId: number;
  category: string;
  categoryProductCount: number;
  products: ProductDto[];
};
export type CategoryProductsDto = {
  categories: CategoryProductDto[];
};
export type GetCategoryWiseProductReqDto = {
  vendorId?: number;
  pageSize?: number;
  searchQuery?: string;
};
export type VendorNameProductDto = {
  defaultImageUrl: string;
  productName: string;
  sku: string;
  category: string;
  categoryId: number;
  company: string;
  vendorId: number;
  subCategory: string;
  subCategoryId: number;
  status: string;
  statusId: number;
  price: number;
  oldPrice?: number | null;
  weight?: number | null;
  tags?: string[];
  weightUnit?: number | null;
  expectedShipHours?: number | null;
  productId?: number;
  quantityAvailable?: number;
  description: string;
  createdAt: string;
  modeId?: number | null;
  rating?: number | null;
  vendorName: string;
};
export type SubCategoryProductDto = {
  subCategoryId: number;
  subCategory: string;
  subCategoryProductCount: number;
  products: VendorNameProductDto[];
};
export type SubCategoryProductsDto = {
  subCategories: SubCategoryProductDto[];
};
export type GetSubCategoryWiseProductReqDto = {
  vendorId?: number;
  pageSize?: number;
  searchQuery?: string;
  categoryId?: number;
  tagId?: number;
  sortingOrder?: string;
  sortingColumn?: string;
};
export type GetProductReqDto = {
  vendorId?: number;
  tagId?: number;
  categoryId?: number;
  subCategoryId?: number;
  statusId?: number;
  isLowStock?: boolean;
  startDate?: string;
  endDate?: string;
  sortingOrder?: string;
  sortingColumn?: string;
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
};
export type ProductImageDto = {
  order?: number;
  imageBlob?: any;
  fileType?: string;
  productImageId?: number;
  productId?: number;
  filePath?: string;
};
export type ProductCharacteristicsDto = {
  name: string;
  value: string;
  id: number;
  productId: number;
};
export type ProductTagsDto = {
  tagId: number;
  id: number;
  productId: number;
  name: string;
};
export type ProductVideoDto = {
  videoId: number;
  filePath: string;
  order: number;
  fileStatusId?: number;
};
export type GetProductResDto = {
  productName: string;
  description?: string;
  sku: string;
  price: number;
  expectedShipHours?: number;
  weight?: number;
  weightUnit?: string;
  oldPrice?: number | null;
  subCategoryId: number;
  statusId: number;
  discountType?: $36EnumsDiscountType | null;
  discountValue?: number | null;
  quantityAvailable: number;
  productId: number;
  defaultImageUrl?: string;
  categoryId?: number;
  category?: string;
  vendorThemeColor?: string;
  vendorId?: number;
  vendorImage?: string;
  serviceTypeId?: number;
  rating?: number;
  deliveryCharges?: string;
  company?: string;
  subCategory?: string;
  status?: string;
  createdAt?: string;
  productImages?: ProductImageDto[];
  characteristics?: ProductCharacteristicsDto[];
  tags?: ProductTagsDto[];
  productVideos?: ProductVideoDto[];
  modeId?: number;
  timeSlots: {
    dayOfWeek: string | null;
    endTime: string;
    startTime: string;
    productId: number | null;
    vendorId: number;
    id: number;
  }[];
};
export type DefaultSelectionPrisma36CategoryPayload = {
  isCatering: boolean;
  serviceTypeId: number;
  name: string;
  id: number;
};
export type Category = DefaultSelectionPrisma36CategoryPayload;
export type SearchProductDto = {
  id: number;
  name: string;
  defaultImageUrl?: string;
  quantityAvailable?: number;
  isProduct?: boolean;
  modeId?: number | null;
  serviceTypeId?: number | null;
};
export type DefaultSelectionPrisma36SubCategoryPayload = {
  imageUrl: string;
  parentCategoryId: number;
  name: string;
  id: number;
};
export type SubCategory = DefaultSelectionPrisma36SubCategoryPayload;
export type AddProductImageDto = {
  order?: number;
  imageBlob?: any;
  fileType?: string;
};
export type AddProductCharacteristicsDto = {
  name: string;
  value: string;
};
export type AddProductTagsDto = {
  tagId: number;
};
export type AddVideoDto = {
  filePath: string;
  order: number;
};
export type AddProductDto = {
  productName: string;
  description?: string;
  sku: string;
  price: number;
  expectedShipHours?: number;
  weight?: number;
  weightUnit?: string;
  oldPrice?: number | null;
  subCategoryId: number;
  statusId: number;
  discountType?: $36EnumsDiscountType | null;
  discountValue?: number | null;
  quantityAvailable: number;
  productImages?: AddProductImageDto[];
  modeId?: number;
  characteristics?: AddProductCharacteristicsDto[];
  tags?: AddProductTagsDto[];
  timeSlots?: {
    dayOfWeek?: string;
    endTime: string;
    startTime: string;
  }[];
  blockDate?: string[];
  videoData?: AddVideoDto;
};
export type RemoveProductImageDto = {
  productImageId?: number;
  filePath?: string;
};
export type EditProductCharacteristicsDto = {
  name: string;
  value: string;
  id?: number;
  productId: number;
};
export type RemoveProductCharacteristicsDto = {
  id?: number;
};
export type EditProductTagsDto = {
  tagId: number;
  id?: number;
  productId: number;
};
export type RemoveProductTagsDto = {
  id: number;
};
export type UpdateVideoDto = {
  filePath: string;
  order: number;
  id?: number;
  isVideoReplaced: boolean;
  statusId?: number;
};
export type EditProductDto = {
  productName: string;
  description?: string;
  sku: string;
  price: number;
  expectedShipHours?: number;
  weight?: number;
  weightUnit?: string;
  oldPrice?: number | null;
  subCategoryId: number;
  statusId: number;
  discountType?: $36EnumsDiscountType | null;
  discountValue?: number | null;
  quantityAvailable: number;
  productImages?: ProductImageDto[];
  id: number;
  modeId?: number;
  removedImages?: RemoveProductImageDto[];
  characteristics?: EditProductCharacteristicsDto[];
  removedCharacteristics?: RemoveProductCharacteristicsDto[];
  tags?: EditProductTagsDto[];
  removedTags?: RemoveProductTagsDto[];
  timeSlots?: {
    dayOfWeek?: string;
    endTime: string;
    startTime: string;
  }[];
  blockDate?: string[];
  removedTimeSlotIds?: number[];
  videoData?: UpdateVideoDto;
  deletedVideoFileObj?: {
    filePath: string;
    id: number;
  };
};
export type DeleteProductDto = {
  id: number;
};
export type MiniProduct = {
  productId: number;
  vendorId: number;
  productName: string;
  defaultImageUrl: string;
  sku: string;
  oldPrice?: number | null;
  weight?: number | null;
  weightUnit?: number | null;
  expectedShipHours?: number | null;
  price: number;
  quantityAvailable: number;
  description: string;
  orderItemCount?: number;
  modeId: number | null;
  rating: number | null;
  serviceTypeId?: number | null;
};
export type MiniPrductsDto = {
  totalCount?: number;
  totalPages?: number;
  products: MiniProduct[];
};
export type DefaultSelectionPrisma36ProductCharacteristicsPayload = {
  value: string;
  name: string;
  productId: number;
  id: number;
};
export type ProductCharacteristics =
  DefaultSelectionPrisma36ProductCharacteristicsPayload;
export type RatingStats = {
  rating: number;
  ratingCount: number;
  ratingPercentage: number;
};
export type ProductRatingStats = {
  totalRatings: number;
  ratingStats: RatingStats[];
};
export type GetProductByIdsResponseDto = {
  id: number;
  serviceTypeId: number;
  productName: string;
  defaultImageUrl: string;
  weight?: number | null;
  weightUnit?: number | null;
  expectedShipHours?: number | null;
  price: number;
  quantityAvailable: number;
  description: string;
  modeId: number | null;
  rating: number | null;
  discountValue: number | null;
  discountType: number | null;
  productTags: {
    name: string;
    id: number;
  }[];
  vendorStatus: string;
  productStatus: string;
  oldPrice: number | null;
};
export type GetOrderRequestDto = {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
  vendorId?: number;
  customerId?: number;
  statusId?: number;
  startDate?: string;
  endDate?: string;
};
export type OrderDto = {
  orderId: number;
  statusId: number;
  oldDeliveryCharges?: number;
  deliveryCharges: number;
  discountAmount?: number;
  selectedDeliveryType: string;
  oldSubTotalAmount?: number;
  subTotalAmount: number;
  vendorId: number;
  serviceTypeId: number;
  vendorCompany: string;
  vendorAddress: string;
  bookedVendorProductTimeSlot: {
    longitude?: number | null;
    latitude?: number | null;
    googleMeetLink: string;
    calenderLink: string;
    bookingDate: string;
    endTime: string;
    startTime: string;
    id: number;
  } | null;
};
export type GetOrdersDto = {
  deliveryPersonAddress: string;
  deliveryPersonNumber: string;
  deliveryPersonName: string;
  billingPersonAddress: string;
  billingPersonNumber: string;
  billingPersonName: string;
  totalAmount: number;
  totalServiceFee: number;
  orders: OrderDto[];
};
export type OrderListDto = {
  orderIds: number[];
};
export type OrderAndCustomerCountsDto = {
  customersCount: number;
  allOrdersCount: number;
};
export type OrderStatusCountsDto = {
  draftedOrdersCount: number;
  deliveredOrdersCount: number;
  cancelledOrdersCount: number;
  activatedOrdersCount: number;
  allOrdersCount: number;
};
export type CustomerCountDto = {
  totalCustomersCount: number;
  activeCustomersCount: number;
};
export type CustomersRelatedProductDto = {
  vendorId: number;
  productId: number;
  productName: string;
  price: number;
  weight?: number | null;
  weightUnit?: number | null;
  expectedShipHours?: number | null;
  defaultImageUrl: string;
  frequency: string;
  quantityAvailable: number;
  description: string;
};
export type DateWiseSalesDto = {
  totalSales: number;
};
export type DateOrDayWiseSalesDto = {
  period: string;
  totalSales: number;
};
export type CartProductDto = {
  defaultImageUrl: string;
  productName: string;
  sku: string;
  category: string;
  categoryId: number;
  company: string;
  vendorId: number;
  subCategory: string;
  subCategoryId: number;
  status: string;
  statusId: number;
  price: number;
  oldPrice?: number | null;
  weight?: number | null;
  tags?: string[];
  weightUnit?: number | null;
  expectedShipHours?: number | null;
  productId?: number;
  quantityAvailable?: number;
  description: string;
  createdAt: string;
  modeId?: number | null;
  rating?: number | null;
  selectedQuantity: number;
  cartItemId: number;
};
export type GetCartVendorWiseProducts = {
  vendorId: number;
  latitude?: number;
  longitude?: number;
  email?: string;
  company: string;
  vendorImage?: string;
  liveSessionUrl?: string | null;
  phone?: string;
  address?: string;
  cityName?: string;
  themeColor?: string;
  rating?: number;
  aboutStore?: string;
  returnInfo?: string;
  tagLine?: string;
  isLive?: boolean;
  estimatedDeliveryTime?: string;
  distance?: string;
  distanceWithOutUnit?: number;
  deliveryCharges?: string;
  deliveryChargesAsNumber?: number;
  vendorTags?: {
    tagName: string;
    tagId?: number;
  }[];
  wallpaperImageUrl?: string | null;
  totalAmountToBePaid?: number | null;
  isQuickDeliveryApplicable?: boolean | null;
  isStandardDeliveryApplicable?: boolean | null;
  products: CartProductDto[];
};
export type ValidateAndGetCartDto = {
  vendors: GetCartVendorWiseProducts[];
  cartId?: number | null;
  totalAmountToBePaid?: number | null;
  isCartInvalidated?: boolean;
};
export type AddOrderResponseDto = {
  cart?: ValidateAndGetCartDto | null;
  deliveryChargesList?: DeliveryChargesDto[] | null;
  stripeSessionUrl?: string | null;
  coinBaseChargeUrl?: string | null;
  orderIds?: number[];
};
export type DeliveryChargesAndNote = {
  vendorId: number;
  selectedDeliveryCharges: number;
  selectedDeliveryType: string;
  externalDeliveryId?: string;
  address?: string;
  phoneNumber?: string;
  customerNote?: string;
  couponCode?: string | null;
  appliedDate?: string | null;
  clickshipServiceId?: string | null;
  modeId: number | null;
};
export type AddOrderDto = {
  cartId: number;
  customerInfo: DeliveryChargesRequestCustomer;
  paymentMethod: string;
  deliveryChargesAndNotes?: DeliveryChargesAndNote[];
  validateTimeSlots?: ValidateTimeSlotsRequestDto;
};
export type GetRecentOrderDto = {
  orderId: number;
  statusId: number;
  statusName: string;
  createdAt: string | string;
  orderItems: {
    modeId?: number | null;
    price: number;
    quantity: number;
    defaultImageUrl: string;
    productName: string;
    productId?: number;
    id: number;
  }[];
};
export type CancelOrderDto = {
  orderId: number;
  cancellationReason: string;
};
export type GetOrdersWithVendorDto = {
  orderId: number;
  statusId: number;
  createdAt: string;
  orderItems: {
    productId: number;
    description?: string | null;
    price: number;
    quantity: number;
    defaultImageUrl: string;
    productName: string;
    id: number;
  }[];
  vendorName: string;
  vendorImage: string;
  canCustomerRate: boolean;
  customerId: string;
};
export type GetOrdersByUserIdDto = {
  activeOrders: GetOrdersWithVendorDto[];
  pastOrders: GetOrdersWithVendorDto[];
  cancelOrders: GetOrdersWithVendorDto[];
};
export type GetSingleOrderByIdDto = {
  orderId: number;
  statusId: number;
  statusName: string;
  createdAt: string | string;
  orderItems: {
    modeId?: number | null;
    price: number;
    quantity: number;
    defaultImageUrl: string;
    productName: string;
    productId?: number;
    id: number;
  }[];
  externalDeliveryTrackingUrl: string | null;
  errorMessage?: string | null;
  externalDeliveryId: string | null;
  externalDeliveryTrackingId: string | null;
  deliveryAddress: string;
  oldDeliveryCharges?: number;
  deliveryCharges: number;
  discountAmount?: number;
  oldTotalAmount?: number;
  totalAmount: number;
  vendorName: string;
  vendorAddress: string;
  vendorId: number;
  vendorEmail: string;
  vendorLat: number | null;
  vendorLng: number | null;
  serviceTypeId: number | null;
  vendorImage: string | null;
  selectedDeliveryType: string;
  serviceFee?: number | null;
  bookedTimeSlotData?: {
    longitude?: number | null;
    latitude?: number | null;
    googleMeetLink: string | null;
    calenderLink: string | null;
    bookingDate: string;
    endTime: string;
    startTime: string;
    id: number;
  } | null;
  coupon: {
    couponTypeId: number;
  } | null;
};
export type GetOrdersWithVendorIdResponseDto = {
  id: number;
  vendorId: number;
  statusId: number;
  createdAt: string;
  totalAmount: number;
  payoutDateTime: string | null;
  deliveryCharges: number | null;
  paymentProcessingFee: number | null;
  serviceFee: number | null;
  payoutId: string | null;
  vendorName: string;
  statusName: string;
  couponVendorId: number | null;
  coupon: {
    couponTypeId: number;
  };
};
export type GetOrdersWithVendorIdDto = {
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  vendorId?: number;
  tag?: string;
  startDate?: string;
  endDate?: string;
};
export type SaveNotificationTokenDto = {
  userId: number;
  notificationToken: string;
};
export type DeleteTokenDto = {
  userId: number;
};
export type CreateLiveSessionDto = {
  title: string;
  startDateTime: string;
  vendorTimezone: string;
  productIds: number[];
};
export type UpdateLiveSessionDto = {
  id: number;
  title?: string;
  startDateTime?: string;
  productIds?: number[];
  statusId?: number;
  removeProductIds?: number[];
  vendorTimezone?: string;
  endDateTime?: string;
};
export type GetLiveSessionDto = {
  id: number;
  vendorId: number;
  title: string;
  liveSessionUrl: string;
  status: string;
  startDateTime: string;
  endDateTime: string;
  products: LiveSessionProductDto[];
  ingestUrl: string | null;
  streamKey: string | null;
};
export type GetRecordedStreamResponseDto = {
  totalCount?: number;
  totalPages?: number;
  liveSessions: {
    createdAt: string;
    totalLikes: number;
    totalViews: number;
    id: number;
    liveSessionUrl: string;
    title: string;
  }[];
};
export type GetAllRecordedStreamsRequestDto = {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
  vendorId: number;
};
export type LiveSessionUpdateResponseDto = {
  streamId: number;
  activeViews: number;
  activeLikes: number;
};
export type LiveSessionUpdateRequestDto = {
  streamId: number;
  action: string;
  state: number;
};
export type SignupWithEmailDto = {
  email: string;
  password: string;
  phoneNumber: string;
  countryCode: string;
  firstName: string;
  lastName: string;
};
export type DeleteCustomerDto = {
  customerId: number;
};
export type SignupWithPhoneDto = {
  phoneNumber: string;
  countryCode: string;
};
export type VerifyOtpDto = {
  OTP: number;
  phoneNumber?: string;
  email?: string;
  countryCode?: string;
};
export type LoginDto = {
  email?: string;
  password: string;
  phoneNumber?: string;
  countryCode?: string;
};
export type ProfileDto = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  password?: string;
  countryCode: string;
};
export type CouponDiscountAppliedOnVendorResponseDto = {
  discountedTotalAmountWithOutDC: number;
  discountedTotalAmount: number;
  discountedTotalDeliveryCharges: number;
  couponAppliedOn: string | null;
  errorMessage?: string;
};
export type VerifyCouponResponseDto = {
  serviceFee: number;
  discountedTotalAmount: number;
  discountedTotalAmountWithOutDC: number;
  discountedTotalDeliveryCharges: number;
  couponDiscountAppliedOnVendorsDictionary: {
    [key: string]: CouponDiscountAppliedOnVendorResponseDto;
  };
};
export type CouponDiscountAppliedOnVendorRequestDto = {
  totalProductsAmount: number;
  totalDeliveryCharges: number;
  couponCode?: string;
  appliedDate?: string;
  productModeId?: number;
};
export type VerifyCouponRequestDto = {
  couponDiscountAppliedOnVendorsDictionary: {
    [key: string]: CouponDiscountAppliedOnVendorRequestDto;
  };
};
export type DefaultSelectionPrisma36CouponPayload = {
  vendorId: number;
  description: string;
  couponValue: number;
  couponTypeId: number;
  statusId: number;
  timesUsed: number;
  maxUsageCount: number;
  expiryDate: string;
  discountValue: number;
  discountType: $36EnumsDiscountType;
  code: string;
  id: number;
};
export type Coupon = DefaultSelectionPrisma36CouponPayload;
export type AddUpdateCouponDto = {
  id?: number | null;
  vendorId?: number | null;
  code: string;
  maxUsageCount: number;
  expiryDate: string;
  couponTypeId: number;
  couponValue: number;
  discountType: $36EnumsDiscountType;
  discountValue: number;
  statusId: number;
  description: string;
};
export type CouponStatsResponseDto = {
  id?: number | null;
  vendorId?: number | null;
  code?: string | null;
  timesUsed?: number | null;
  maxUsageCount?: number | null;
  expiryDate?: string | null;
  couponType?: string | null;
  couponValue?: number | null;
  couponTypeName?: number;
  vendorName?: string | null;
  description: string | null;
};
export type GetCouponStatsDto = {
  pageNumber?: number | null;
  pageSize?: number | null;
  vendorId?: number | null;
  statusId?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  searchQuery?: string | null;
  sortingColumn?: string | null;
  sortingOrder?: string | null;
  discountType?: $36EnumsDiscountType | null;
  discountValue?: number | null;
  couponTypeId?: number | null;
  couponStatusId?: number | null;
};
export type DefaultSelectionPrisma36CouponTypePayload = {
  description: string;
  name: string;
  id: number;
};
export type CouponType = DefaultSelectionPrisma36CouponTypePayload;
export type CouponsWithMaxDiscountDto = {
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  vendorId?: number | null;
  currentDate: string;
  discountType?: $36EnumsDiscountType | null;
};
export type ContactFormSubmissionDto = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  companyName?: string;
  companyWebsite?: string;
  businessAddress?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  numberOfStores?: number;
  heardAboutUs?: string;
  message: string;
};
export type GetAllCategoriesRequestDto = {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
  serviceTypeId?: number;
};
export type GetAllSubCategoriesRequestDto = {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
  parentCategoryId?: number;
  serviceTypeId?: number;
};
export type SubCategoryDto = {
  name: string;
  id: number;
  imageUrl: string;
  serviceTypeId: number;
};
export type AllCategoriesResponseDto = {
  name: string;
  id: number;
  SubCategory: SubCategoryDto[];
};
export type GetCartResponseDto = {
  vendors: GetCartVendorWiseProducts[];
  cartId?: number | null;
  totalAmountToBePaid?: number | null;
};
export type DeleteCartRequestDto = {
  cartId?: number | null;
  cartItemId?: number | null;
};
export type AddToCartResponseDto = {
  cartItemId?: number;
  cartId?: number;
};
export type AddToCartRequestDto = {
  cartItemId?: number;
  customerId: number;
  vendorId: number;
  productId: number;
  quantity: number;
  isCartServiceType?: boolean;
};
export type UpdateAndGetCartRequestDto = {
  cartItemId?: number;
  customerId: number;
  vendorId: number;
  productId: number;
  quantity: number;
  isCartServiceType?: boolean;
  latitude?: number;
  longitude?: number;
};
export type EventDto = {
  summary: string;
  description?: string;
  startTime: string;
  endTime: string;
  recurrence?: string;
  timeZone?: string;
  vendorId: number;
  attendees?: string[];
  status: string;
  location: string;
};
export type UpdateEventDto = {
  summary: string;
  description?: string;
  startTime: string;
  endTime: string;
  recurrence?: string;
  timeZone?: string;
  vendorId: number;
  attendees?: string[];
  status: string;
  location: string;
  eventId: string;
};
export type DeleteEventDto = {
  eventId: string;
  vendorId: number;
};
export type SsoLoginResponseDto = {
  thirdPartyToken: string;
  oAuthToken: string;
  tokenSource: string;
  isNewUser: boolean;
};
export type AdminSignupDto = {
  email: string;
  password?: string;
  firstName: string;
  lastName: string;
  statusId: number;
  id?: number;
};
export type AdminLoginDto = {
  email: string;
  password: string;
};
export type GetVendorsDto = {
  totalCount?: number;
  totalPages?: number;
  id: number;
  company: string;
  statusId: number;
  createdAt: string;
  email: string;
  phone: string;
  statusName: string;
  user: string;
  vendorImage: string;
  isCatering: boolean;
};
export type GetAdminResponseDto = {
  id: number;
  userName: string;
  email: string;
  statusName: string;
  statusId: number;
  createdAt: string;
};
export type GetAdminRequestDto = {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
  statusId?: number;
};
export type VendorStatusDto = {
  vendorId: number;
  lookupId: number;
};
export type DefaultSelectionPrisma36LookupPayload = {
  parentLookupId: number;
  name: string;
  code: string;
  id: number;
};
export type Lookup = DefaultSelectionPrisma36LookupPayload;
export type LookupIdDto = {
  lookupId: number | null;
};
export type TagsResponseDto = {
  id: number;
  name: string;
  parentId: number | null;
  serviceTypeId: number;
  serviceTypeName: string;
};
export type Customer = {
  id: number;
  email: string;
  phoneNumber: string;
  name: string;
  isVerified: boolean;
  createdAt: string;
  deleted: boolean;
};
export type GetCustomerResDto = {
  customers: Customer[];
  totalCount?: number;
  totalPages?: number;
};
export type GetCustomersReqDto = {
  searchQuery?: string;
  pageNumber?: number;
  pageSize?: number;
  getTotalCount?: boolean;
  sortingColumn?: string;
  sortingOrder?: "asc" | "desc";
  startDate?: string;
  endDate?: string;
  isVerified?: boolean;
  deleted?: boolean;
};
export const {
  useHandleCoinBaseWebhookMutation,
  useGetPresignedUrlMutation,
  useGetPresignedUrlForChatMutation,
  useGetRecommendedVideosMutation,
  useVideoBulkUpdateMutation,
  useAddVideoMutation,
  useGetVideosMutation,
  useGetVideoByIdMutation,
  useUpdateVideoMutation,
  useReplaceFilePathMutation,
  useDeleteVideoMutation,
  useVideoByUrlQuery,
  useCreateVendorProductTimeSlotMutation,
  useGetVendorProductTimeSlotsMutation,
  useGetAvailableTimeSlotsMutation,
  useValidateTimeSlotMutation,
  useBookTimeSlotMutation,
  useGetUpcomingEventsMutation,
  useEditBookedEventMutation,
  useDeleteBookedEventMutation,
  useRevokeTokenMutation,
  useVendorSignupMutation,
  useVendorLoginMutation,
  useVendorProductsMutation,
  useGetVendorsWithDiscountsMutation,
  useGetGroupedByVendorsQuery,
  useGetVendorsByTagOrServiceTypeIdMutation,
  useGetRecomendedStoresQuery,
  useGetStoresWithDiscountButNoOrderQuery,
  useGetNearbyVendorsMutation,
  useGetVendorDetailsQuery,
  useGetDeliveryChargesMutation,
  useUpdateVendorDetailsMutation,
  useGetVendorByIdsMutation,
  useGetVendorBySearchQuery,
  useGetAllVendorNameOrIdQuery,
  useGeActiveVendorsMutation,
  useGetStripeAccountLinkQuery,
  useCalculateAmountQuery,
  useBookRideMutation,
  useGetDeliveryStatusQuery,
  useAddVendorTagMutation,
  useUpdateVendorTagMutation,
  useGetVendorTagByIdQuery,
  useAddProductTagMutation,
  useUpdateProductTagMutation,
  useGetProductTagByIdQuery,
  useGetTagsBySubcategoryIdQuery,
  useGetAllVendorTagsMutation,
  useGetAllProductTagsMutation,
  useCheckTagUniqueNameQuery,
  useCreateStripeConnectedAccountMutation,
  usePayoutToVendorMutation,
  useDeleteStripeAccountQuery,
  useGetAllServiceTypesMutation,
  useAddServiceTypeMutation,
  useUpdateServiceTypeMutation,
  useGetServiceTypeByIdQuery,
  useGetRatingByCustomerQuery,
  useCanCustomerRateQuery,
  useGetRatingsByProductQuery,
  useGetRatingsByCustomerQuery,
  useSetReviewSelectionMutation,
  useGetRatingsByVendorMutation,
  useAddUpdateProductRatingMutation,
  useGetRatingByIdQuery,
  useAddVendorReplyMutation,
  useGetVendorWiseProductsMutation,
  useGetCategoryWiseProductsMutation,
  useGetSubCategoryWiseProductsMutation,
  useGetProductsMutation,
  useGetProductByIdQuery,
  useGetCategoryQuery,
  useSearchProductQuery,
  useGetSubCategoryQuery,
  useAddProductMutation,
  useEditProductMutation,
  useDeleteProductMutation,
  useGetPopularProductsQuery,
  useGetRecommendedProductsQuery,
  useGetProductCharacteristicsByidQuery,
  useGetProductRatingStatsQuery,
  useCheckSkuUniqueQuery,
  useGetProductByIdsMutation,
  useGetOrdersMutation,
  useGetOrderByIdQuery,
  useGetOrdersByIdsMutation,
  useGetOrderAndCustomerCountsQuery,
  useGetOrderStatusCountsQuery,
  useGetCustomersCountsQuery,
  useGetCustomersRelatedProductQuery,
  useGetDateWiseSalesCountsQuery,
  useGetDateOrDayWiseSalesQuery,
  useUpdateOrderStatusMutation,
  useDeleteOrdersMutation,
  useAddOrderMutation,
  useGetRecentOrdersQuery,
  useCancelOrderMutation,
  useGetOrdersByUserIdQuery,
  useGetSingleOrderByIdQuery,
  useGetOrdersWithVendorIdMutation,
  usePendingPaymentOrdersQuery,
  useOrderScheduleMutation,
  useGetClickShipRatesForVendorMutation,
  useBookShipmentByVendorMutation,
  useSaveNotificationTokenMutation,
  useDeleteNotificationTokenMutation,
  useTestDoordashQuery,
  useSendNotificationMutation,
  useCreateLiveSessionMutation,
  useUpdateLiveSessionMutation,
  useGetLiveSessionsQuery,
  useGetAllRecordedStreamsMutation,
  useLiveSessionUpdateMutation,
  useSignupWithEmailMutation,
  useDeleteCustomerMutation,
  useSignupWithPhoneMutation,
  useVerifyOtpMutation,
  useResendOtpMutation,
  useCustomerLoginMutation,
  useCustomerLoginWithPhoneMutation,
  useUpdateProfileMutation,
  useVerifyCouponAndGetVendorWiseAppliedDiscountsMutation,
  useVerifyCouponAndGetDiscountedValueQuery,
  useAddUpdateCouponMutation,
  useGetCouponStatsMutation,
  useGetCouponTypesMutation,
  useCouponsWithMaxDiscountMutation,
  useForgotPasswordMutation,
  useCommonVerifyOtpMutation,
  useSendOtpMutation,
  useResetPasswordMutation,
  useSendContactUsEmailMutation,
  useGetTotalStatsQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useGetCategoryByIdQuery,
  useGetAllCategoriesMutation,
  useGetAllSubCategoriesMutation,
  useAddSubCategoryMutation,
  useUpdateSubCategoryMutation,
  useGetSubCategoryByIdQuery,
  useCheckCategoryUniqueQuery,
  useCheckSubCategoryUniqueQuery,
  useAllCategoriesQuery,
  useGetCartQuery,
  useDeleteCartOrCartItemMutation,
  useAddToCartMutation,
  useUpdateAndGetCartMutation,
  useValidateAndGetCartQuery,
  useCreateEventMutation,
  useUpdateEventMutation,
  useDeleteEventMutation,
  useGoogleLoginQuery,
  useGoogleGetTokenByCodeQuery,
  useGoogleGetTokenCodeForCalenderQuery,
  useAppleLoginQuery,
  useAppleGetTokenByCodeMutation,
  useAddAdminMutation,
  useAdminLoginMutation,
  useGetVendorsMutation,
  useGetAdminsMutation,
  useUpdateVendorStatusMutation,
  useGetLookupValuesMutation,
  useGetTagsValuesMutation,
  useAddTagsValuesMutation,
  useGetCustomersMutation,
} = injectedRtkApi;
